package com.havn.app

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.tween
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.NavigationRail
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.runtime.State
import com.havn.app.core.di.AppContainer
import com.havn.app.core.billing.HavnBillingService
import com.havn.app.core.billing.HavnPlans
import com.havn.app.core.designsystem.HavnIcon
import com.havn.app.core.designsystem.HavnIconKey
import com.havn.app.core.designsystem.HavnPushNavigation
import com.havn.app.core.designsystem.HavnSpacing
import com.havn.app.core.designsystem.HavnTheme
import com.havn.app.core.designsystem.havnIsWebShell
import com.havn.app.core.designsystem.havnUsesMaterialSidebar
import com.havn.app.core.designsystem.havnUsesLiquidSidebar
import com.havn.app.core.designsystem.havnUsesRootSafeDrawingInsets
import com.havn.app.core.designsystem.havnUsesRootStatusBarInsets
import com.havn.app.core.platform.HavnExternalActions
import com.havn.app.core.platform.havnIsTabletDevice
import com.havn.app.ui.theme.HavnThemeManager
import com.havn.app.ui.theme.HavnThemeType
import com.havn.app.ui.theme.LocalHavnThemeTokens
import com.havn.app.ui.theme.asAppearanceTheme
import com.havn.app.core.localization.HavnLocalizationProvider
import com.havn.app.core.localization.HavnLanguage
import com.havn.app.core.localization.LocalHavnLanguage
import com.havn.app.core.localization.LocalHavnStrings
import com.havn.app.core.localization.localizedShortLabel
import com.havn.app.core.localization.localizedTitle
import com.havn.app.core.media.HavnDatabaseImage
import com.havn.app.core.media.HavnFilePicker
import com.havn.app.core.media.HavnPhotoPicker
import com.havn.app.core.media.havnAgentAvatarPreviewSource
import com.havn.app.core.media.havnLargePropertyPhotoSource
import com.havn.app.core.media.havnPreloadDatabaseImage
import com.havn.app.core.navigation.HavnDestination
import com.havn.app.core.settings.LocalHavnUnitPreferences
import com.havn.app.core.supabase.HavnSupabaseConfig
import com.havn.app.features.agency.domain.HavnSubscriptionTier
import com.havn.app.features.agency.domain.AgencyMember
import com.havn.app.features.agency.presentation.AgencyScreen
import com.havn.app.features.agency.presentation.AgencyViewModel
import com.havn.app.features.analytics.presentation.AnalyticsScreen
import com.havn.app.features.attachments.domain.HavnAttachmentRecipient
import com.havn.app.features.attachments.domain.HavnAttachmentRecipientSource
import com.havn.app.features.attachments.presentation.FilesScreen
import com.havn.app.features.attachments.presentation.AttachmentsViewModel
import com.havn.app.features.auth.domain.AuthRepository
import com.havn.app.features.auth.domain.AuthState
import com.havn.app.features.auth.presentation.AuthScreen
import com.havn.app.features.auth.presentation.AuthViewModel
import com.havn.app.features.clients.domain.Client
import com.havn.app.features.clients.presentation.ClientsScreen
import com.havn.app.features.clients.presentation.ClientsViewModel
import com.havn.app.features.dashboard.presentation.DashboardScreen
import com.havn.app.features.followups.presentation.FollowUpsScreen
import com.havn.app.features.followups.presentation.FollowUpsViewModel
import com.havn.app.features.leads.presentation.LeadsScreen
import com.havn.app.features.leads.presentation.LeadsViewModel
import com.havn.app.features.openhouses.presentation.OpenHousesScreen
import com.havn.app.features.openhouses.presentation.OpenHousesMode
import com.havn.app.features.openhouses.presentation.OpenHousesViewModel
import com.havn.app.features.openhouses.presentation.KioskBranding
import com.havn.app.features.notifications.domain.NotificationRepository
import com.havn.app.features.notifications.presentation.NotificationCoordinator
import com.havn.app.features.notifications.platform.HavnPushNotifications
import com.havn.app.features.properties.domain.Property
import com.havn.app.features.properties.domain.PropertyPhoto
import com.havn.app.features.properties.presentation.PropertiesScreen
import com.havn.app.features.properties.presentation.PropertiesViewModel
import com.havn.app.features.reports.presentation.SellerReportsScreen
import com.havn.app.features.reports.presentation.SellerReportsViewModel
import com.havn.app.features.settings.domain.McpApiKeyRepository
import com.havn.app.features.settings.presentation.SettingsScreen
import com.havn.app.features.tasks.presentation.TaskDetailBackTarget
import com.havn.app.features.tasks.presentation.TasksScreen
import com.havn.app.features.tasks.presentation.TasksViewModel
import havn.composeapp.generated.resources.Res
import havn.composeapp.generated.resources.havn_auth_logo
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.painterResource

@Composable
fun HavnApp(
    navigationState: HavnNavigationState? = null,
    showSystemNavigation: Boolean = true,
    showLaunchOverlay: Boolean = true,
    photoPicker: HavnPhotoPicker = HavnPhotoPicker.Unavailable,
    filePicker: HavnFilePicker = HavnFilePicker.Unavailable,
    onSystemNavigationVisibleChanged: (Boolean) -> Unit = {},
    onKioskModeChanged: (Boolean) -> Unit = {}
) {
    val container = remember { AppContainer.default() }
    val themeType by container.themeManager.themeType.collectAsState()
    val systemDark = isSystemInDarkTheme()
    val effectiveThemeType = if (havnIsWebShell) {
        themeType.asAppearanceTheme()
    } else if (systemDark) {
        HavnThemeType.OBSIDIAN_GOLD
    } else {
        HavnThemeType.LIGHT
    }
    HavnTheme(themeType = effectiveThemeType) {
        val language by container.languageRepository.language.collectAsState()
        val unitPreferences by container.unitPreferencesRepository.preferences.collectAsState()
        var showLaunchScreen by remember(showLaunchOverlay) { mutableStateOf(showLaunchOverlay && !havnIsWebShell) }
        var launchMinimumElapsed by remember { mutableStateOf(havnIsWebShell) }
        var launchLoggedOutAllowed by remember { mutableStateOf(havnIsWebShell) }
        var launchExiting by remember { mutableStateOf(false) }
        var launchGateCycle by remember { mutableStateOf(0) }
        LaunchedEffect(launchGateCycle) {
            if (havnIsWebShell) {
                launchMinimumElapsed = true
                launchLoggedOutAllowed = true
                return@LaunchedEffect
            }
            launchMinimumElapsed = false
            launchLoggedOutAllowed = false
            delay(1_000)
            launchMinimumElapsed = true
            delay(1_200)
            launchLoggedOutAllowed = true
        }
        val authViewModel = remember { AuthViewModel(container.authRepository) }
        val propertiesViewModel = remember {
            PropertiesViewModel(
                container.propertyRepository,
                container.clientRepository,
                container.leadRepository,
                container.authRepository,
                container.unitPreferencesRepository,
                container.agencyRepository
            )
        }
        val openHousesViewModel = remember {
            OpenHousesViewModel(
                container.openHouseRepository,
                container.clientRepository,
                container.authRepository,
                container.agencyRepository
            )
        }
        val leadsViewModel = remember {
            LeadsViewModel(container.leadRepository, container.authRepository, container.agencyRepository)
        }
        val clientsViewModel = remember {
            ClientsViewModel(container.clientRepository, container.authRepository, container.agencyRepository, container.leadRepository)
        }
        val followUpsViewModel = remember {
            FollowUpsViewModel(
                followUpRepository = container.followUpRepository,
                leadRepository = container.leadRepository,
                aiFollowUpService = container.aiFollowUpService,
                attachmentRepository = container.attachmentRepository,
                authRepository = container.authRepository,
                languageRepository = container.languageRepository
            )
        }
        val sellerReportsViewModel = remember {
            SellerReportsViewModel(
                sellerReportRepository = container.sellerReportRepository,
                sellerReportAiService = container.sellerReportAiService,
                openHouseRepository = container.openHouseRepository,
                authRepository = container.authRepository
            )
        }
        val tasksViewModel = remember {
            TasksViewModel(
                taskRepository = container.taskRepository,
                authRepository = container.authRepository
            )
        }
        val attachmentsViewModel = remember {
            AttachmentsViewModel(
                attachmentRepository = container.attachmentRepository,
                authRepository = container.authRepository
            )
        }
        val agencyViewModel = remember {
            AgencyViewModel(container.agencyRepository, container.authRepository)
        }
        val notificationCoordinator = remember {
            NotificationCoordinator(container.authRepository, container.notificationRepository)
        }
        LaunchedEffect(notificationCoordinator, propertiesViewModel, openHousesViewModel) {
            propertiesViewModel.onPropertyCreated {
                notificationCoordinator.maybeRequestAfterFirstBusinessAction(hasAnyProperty = true, hasAnyOpenHouse = false)
            }
            openHousesViewModel.onOpenHouseScheduled {
                notificationCoordinator.maybeRequestAfterFirstBusinessAction(hasAnyProperty = false, hasAnyOpenHouse = true)
            }
        }
        val openHousesAppState by openHousesViewModel.uiState.collectAsState()
        val propertiesAppState by propertiesViewModel.uiState.collectAsState()
        val leadsAppState by leadsViewModel.uiState.collectAsState()
        LaunchedEffect(openHousesAppState.mode) {
            onKioskModeChanged(openHousesAppState.mode.usesKioskImmersiveChrome())
        }
        val agencyState by agencyViewModel.uiState.collectAsState()
        LaunchedEffect(agencyState.hasLoadedEntitlement, agencyState.entitlement) {
            if (!agencyState.hasLoadedEntitlement) return@LaunchedEffect
            propertiesViewModel.refreshEntitlement(agencyState.entitlement.tier)
            openHousesViewModel.refreshEntitlement(agencyState.entitlement.tier)
            clientsViewModel.refreshEntitlement(agencyState.entitlement.tier)
            leadsViewModel.refreshEntitlement(agencyState.entitlement.tier)
        }
        val effectiveAgencyContextId = agencyState.selectedAgencyId
        val actAsAgent = agencyState.isActingLikeAgent && agencyState.canActLikeAgent
        LaunchedEffect(agencyState.hasLoadedEntitlement, effectiveAgencyContextId, actAsAgent) {
            if (!agencyState.hasLoadedEntitlement) return@LaunchedEffect
            propertiesViewModel.setAgencyContext(effectiveAgencyContextId, actAsAgent)
            openHousesViewModel.setAgencyContext(effectiveAgencyContextId, actAsAgent)
            clientsViewModel.setAgencyContext(effectiveAgencyContextId)
            leadsViewModel.setAgencyContext(effectiveAgencyContextId, actAsAgent)
            tasksViewModel.setAgencyContext(effectiveAgencyContextId, actAsAgent)
            sellerReportsViewModel.setAgencyContext(effectiveAgencyContextId, actAsAgent)
        }
        DisposableEffect(
            authViewModel,
            propertiesViewModel,
            openHousesViewModel,
            clientsViewModel,
            leadsViewModel,
            followUpsViewModel,
            sellerReportsViewModel,
            tasksViewModel,
            attachmentsViewModel,
            agencyViewModel,
            notificationCoordinator
        ) {
            onDispose {
                authViewModel.dispose()
                propertiesViewModel.dispose()
                openHousesViewModel.dispose()
                clientsViewModel.dispose()
                leadsViewModel.dispose()
                followUpsViewModel.dispose()
                sellerReportsViewModel.dispose()
                tasksViewModel.dispose()
                attachmentsViewModel.dispose()
                agencyViewModel.dispose()
                notificationCoordinator.dispose()
            }
        }
        val authUiState by authViewModel.uiState.collectAsState()
        val launchTodayImageSources = remember(propertiesAppState.properties) {
            todayLaunchImageSources(
                properties = propertiesAppState.properties
            )
        }
        val launchTodayImageSignature = remember(launchTodayImageSources) {
            launchTodayImageSources.joinToString(separator = "|") { "${it.dataUrl}:${it.previewDataUrl}" }
        }
        var launchPreloadedImageSignature by remember { mutableStateOf<String?>(null) }
        val launchTodayImagesReady =
            launchTodayImageSources.isEmpty() || launchPreloadedImageSignature == launchTodayImageSignature
        var previousAuthUserId by remember { mutableStateOf<String?>(null) }
        LaunchedEffect(authUiState.authState) {
            if (havnIsWebShell) return@LaunchedEffect
            when (val authState = authUiState.authState) {
                is AuthState.LoggedIn -> {
                    val nextUserId = authState.user.id
                    val shouldStartSignedInGate =
                        previousAuthUserId != nextUserId &&
                            !showLaunchScreen &&
                            authUiState.isSessionRestoreComplete
                    previousAuthUserId = nextUserId
                    if (shouldStartSignedInGate) {
                        launchExiting = false
                        launchPreloadedImageSignature = null
                        showLaunchScreen = true
                        launchGateCycle += 1
                    }
                }
                AuthState.LoggedOut,
                is AuthState.Error -> {
                    previousAuthUserId = null
                }
                AuthState.Loading -> Unit
            }
        }
        LaunchedEffect(launchTodayImageSignature) {
            if (launchTodayImageSources.isEmpty()) {
                launchPreloadedImageSignature = launchTodayImageSignature
                return@LaunchedEffect
            }
            launchTodayImageSources.forEach { source ->
                havnPreloadDatabaseImage(
                    dataUrl = source.dataUrl,
                    previewDataUrl = source.previewDataUrl
                )
            }
            launchPreloadedImageSignature = launchTodayImageSignature
        }
        val launchReadyForSignedInUser =
            launchMinimumElapsed &&
                agencyState.hasLoadedEntitlement &&
                propertiesAppState.hasLoadedInitialPage &&
                openHousesAppState.hasLoadedInitialPage &&
                openHousesAppState.hasLoadedPropertyOptions &&
                leadsAppState.hasLoadedInitialPage &&
                launchTodayImagesReady
        val launchReadyForSignedOutUser =
            authUiState.isSessionRestoreComplete && launchLoggedOutAllowed
        LaunchedEffect(
            showLaunchScreen,
            launchReadyForSignedInUser,
            launchReadyForSignedOutUser,
            launchExiting,
            authUiState.authState
        ) {
            if (!showLaunchScreen || launchExiting || havnIsWebShell) return@LaunchedEffect
            val canExitLaunch = when (authUiState.authState) {
                is AuthState.LoggedIn -> launchReadyForSignedInUser
                AuthState.LoggedOut,
                is AuthState.Error -> launchReadyForSignedOutUser
                AuthState.Loading -> false
            }
            if (canExitLaunch) {
                launchExiting = true
            }
        }
        LaunchedEffect(launchExiting) {
            if (launchExiting) {
                delay(380)
                showLaunchScreen = false
            }
        }
        LaunchedEffect(authUiState.authState, showLaunchScreen, showSystemNavigation, openHousesAppState.mode) {
            onSystemNavigationVisibleChanged(
                (showSystemNavigation || navigationState != null) &&
                    !showLaunchScreen &&
                    authUiState.authState is AuthState.LoggedIn &&
                    !openHousesAppState.mode.usesKioskImmersiveChrome()
            )
        }
        var internalDestination by rememberSaveable { mutableStateOf(HavnDestination.Dashboard) }
        var resetToTodayAfterSignIn by remember { mutableStateOf(false) }
        val externalDestination: State<HavnDestination>? =
            navigationState?.selectedDestination?.collectAsState(HavnDestination.Dashboard)
        val destination = externalDestination?.value ?: internalDestination
        val externalRootRequestCount: Int? =
            navigationState?.rootNavigationRequestCount?.collectAsState(0)?.value
        val onDestinationSelected: (HavnDestination) -> Unit = { nextDestination ->
            if (navigationState == null) {
                internalDestination = nextDestination
            } else {
                navigationState.selectDestination(nextDestination)
            }
        }
        val resetDestinationToRoot: (HavnDestination) -> Unit = { rootDestination ->
            resetDestinationToRoot(
                destination = rootDestination,
                propertiesViewModel = propertiesViewModel,
                openHousesViewModel = openHousesViewModel,
                leadsViewModel = leadsViewModel,
                clientsViewModel = clientsViewModel,
                followUpsViewModel = followUpsViewModel,
                sellerReportsViewModel = sellerReportsViewModel,
                attachmentsViewModel = attachmentsViewModel
            )
        }
        val onTabSelected: (HavnDestination) -> Unit = { nextDestination ->
            resetDestinationToRoot(nextDestination)
            onDestinationSelected(nextDestination)
        }

        LaunchedEffect(authUiState.authState) {
            when (authUiState.authState) {
                AuthState.LoggedOut,
                is AuthState.Error -> resetToTodayAfterSignIn = true
                is AuthState.LoggedIn -> {
                    if (resetToTodayAfterSignIn) {
                        resetDestinationToRoot(HavnDestination.Dashboard)
                        onDestinationSelected(HavnDestination.Dashboard)
                        resetToTodayAfterSignIn = false
                    }
                }
                AuthState.Loading -> Unit
            }
        }

        if (externalRootRequestCount != null) {
            LaunchedEffect(externalRootRequestCount) {
                resetDestinationToRoot(destination)
            }
        }

        val focusManager = LocalFocusManager.current

        HavnLocalizationProvider(language = language) {
            androidx.compose.runtime.CompositionLocalProvider(LocalHavnUnitPreferences provides unitPreferences) {
            Box(
                Modifier
                    .fillMaxSize()
                    .pointerInput(Unit) {
                        detectTapGestures(onTap = { focusManager.clearFocus() })
                    }
            ) {
                if (showLaunchScreen && !havnIsWebShell) {
                    HavnLaunchScreen(exiting = launchExiting)
                } else {
                    when (authUiState.authState) {
                        AuthState.Loading -> HavnLaunchScreen(exiting = false)
                        AuthState.LoggedOut,
                        is AuthState.Error -> {
                            AuthScreen(
                                uiState = authUiState,
                                onEmailChanged = authViewModel::onEmailChanged,
                                onOtpCodeChanged = authViewModel::onOtpCodeChanged,
                                onSendEmailOtp = authViewModel::sendEmailOtp,
                                onVerifyEmailOtp = authViewModel::verifyEmailOtp,
                                onSignInWithGoogle = authViewModel::signInWithGoogle,
                                onSignInWithApple = authViewModel::signInWithApple,
                                onShowWelcome = authViewModel::showWelcome,
                                onShowEmailEntry = authViewModel::showEmailEntry,
                                selectedLanguage = language,
                                onLanguageSelected = container.languageRepository::setLanguage
                            )
                        }
                        is AuthState.LoggedIn -> AuthenticatedApp(
                            destination = destination,
                            authState = authUiState.authState,
                            showSystemNavigation = showSystemNavigation,
                            onDestinationSelected = onDestinationSelected,
                            onTabSelected = onTabSelected,
                            onLogout = authViewModel::logout,
                            propertiesViewModel = propertiesViewModel,
                            openHousesViewModel = openHousesViewModel,
                            leadsViewModel = leadsViewModel,
                            clientsViewModel = clientsViewModel,
                            followUpsViewModel = followUpsViewModel,
                            sellerReportsViewModel = sellerReportsViewModel,
                            tasksViewModel = tasksViewModel,
                            attachmentsViewModel = attachmentsViewModel,
                            agencyViewModel = agencyViewModel,
                            photoPicker = photoPicker,
                            filePicker = filePicker,
                            authRepository = container.authRepository,
                            languageRepository = container.languageRepository,
                            unitPreferencesRepository = container.unitPreferencesRepository,
                            kioskSecurityRepository = container.kioskSecurityRepository,
                            mcpApiKeyRepository = container.mcpApiKeyRepository,
                            themeManager = container.themeManager,
                            notificationRepository = container.notificationRepository,
                            billingService = container.billingService,
                            analyticsAiService = container.analyticsAiService,
                            externalRootNavigationRequestCount = externalRootRequestCount
                        )
                    }
                }
                if (!showLaunchScreen || havnIsWebShell) {
                    HavnEnvironmentBadge()
                }
            }
            }
        }
    }
}

private data class HavnStartupImageSource(
    val dataUrl: String?,
    val previewDataUrl: String? = null
)

private fun todayLaunchImageSources(
    properties: List<Property>
): List<HavnStartupImageSource> {
    val activeProperties = properties.filter { it.status == com.havn.app.features.properties.domain.PropertyStatus.Active }
    val featuredProperty = activeProperties.firstOrNull()
    val heroPhoto = featuredProperty?.todayHeroPhoto() ?: return emptyList()
    val heroDataUrl = havnLargePropertyPhotoSource(heroPhoto.storagePath)
        ?.takeUnless { it == heroPhoto.thumbnailDataUrl }
        ?: heroPhoto.thumbnailDataUrl
    val sources = mutableListOf(
        HavnStartupImageSource(
            dataUrl = heroDataUrl,
            previewDataUrl = heroPhoto.thumbnailDataUrl
        )
    )
    featuredProperty.photos
        .take(3)
        .forEach { photo ->
            sources += HavnStartupImageSource(
                dataUrl = photo.thumbnailDataUrl,
                previewDataUrl = photo.thumbnailDataUrl
            )
        }
    return sources
        .filter { !it.dataUrl.isNullOrBlank() || !it.previewDataUrl.isNullOrBlank() }
        .distinctBy { "${it.dataUrl}|${it.previewDataUrl}" }
}

private fun Property.todayHeroPhoto(): PropertyPhoto? =
    photos.firstOrNull { it.storagePath == heroPhotoPath }
        ?: photos.firstOrNull { it.isHero }
        ?: photos.firstOrNull()

@Composable
private fun BoxScope.HavnEnvironmentBadge() {
    if (HavnSupabaseConfig.environment != "sandbox") return
    Text(
        text = "SANDBOX",
        color = Color(0xFF111827),
        style = MaterialTheme.typography.labelSmall,
        fontWeight = FontWeight.Bold,
        modifier = Modifier
            .align(Alignment.TopCenter)
            .padding(top = 10.dp)
            .clip(RoundedCornerShape(6.dp))
            .background(Color(0xFFF4C542))
            .border(1.dp, Color(0xFF8A6A12), RoundedCornerShape(6.dp))
            .padding(horizontal = 10.dp, vertical = 4.dp)
    )
}

@Composable
private fun HavnLaunchScreen(exiting: Boolean) {
    val theme = LocalHavnThemeTokens.current
    val overlayVisibility = remember { Animatable(1f) }
    val contentVisibility = remember { Animatable(0f) }
    val highlightProgress = remember { Animatable(0f) }
    LaunchedEffect(Unit) {
        contentVisibility.animateTo(
            targetValue = 1f,
            animationSpec = tween(durationMillis = 420, easing = FastOutSlowInEasing)
        )
    }
    LaunchedEffect(Unit) {
        while (true) {
            highlightProgress.snapTo(0f)
            highlightProgress.animateTo(
                targetValue = 1f,
                animationSpec = tween(durationMillis = 1_450, easing = LinearEasing)
            )
        }
    }
    LaunchedEffect(exiting) {
        if (!exiting) return@LaunchedEffect
        overlayVisibility.animateTo(
            targetValue = 0f,
            animationSpec = tween(durationMillis = 360, easing = FastOutSlowInEasing)
        )
    }
    val overlayValue = overlayVisibility.value
    val contentValue = contentVisibility.value
    val pulse = 0.94f + ((1f - kotlin.math.abs((highlightProgress.value * 2f) - 1f)) * 0.06f)
    Box(
        modifier = Modifier
            .fillMaxSize()
            .alpha(overlayValue)
            .background(theme.background),
        contentAlignment = Alignment.Center
    ) {
        Image(
            painter = painterResource(Res.drawable.havn_auth_logo),
            contentDescription = null,
            modifier = Modifier
                .size(156.dp)
                .alpha(contentValue)
                .scale((0.92f + (contentValue * 0.08f)) * pulse)
        )
    }
}

@Composable
private fun AuthenticatedApp(
    destination: HavnDestination,
    authState: AuthState,
    showSystemNavigation: Boolean,
    onDestinationSelected: (HavnDestination) -> Unit,
    onTabSelected: (HavnDestination) -> Unit,
    onLogout: () -> Unit,
    propertiesViewModel: PropertiesViewModel,
    openHousesViewModel: OpenHousesViewModel,
    leadsViewModel: LeadsViewModel,
    clientsViewModel: ClientsViewModel,
    followUpsViewModel: FollowUpsViewModel,
    sellerReportsViewModel: SellerReportsViewModel,
    tasksViewModel: TasksViewModel,
    attachmentsViewModel: AttachmentsViewModel,
    agencyViewModel: AgencyViewModel,
    photoPicker: HavnPhotoPicker,
    filePicker: HavnFilePicker,
    authRepository: AuthRepository,
    languageRepository: com.havn.app.core.localization.HavnLanguageRepository,
    unitPreferencesRepository: com.havn.app.core.settings.HavnUnitPreferencesRepository,
    kioskSecurityRepository: com.havn.app.core.settings.HavnKioskSecurityRepository,
    mcpApiKeyRepository: McpApiKeyRepository,
    themeManager: HavnThemeManager,
    notificationRepository: NotificationRepository,
    billingService: HavnBillingService,
    analyticsAiService: com.havn.app.features.analytics.domain.AnalyticsAiService,
    externalRootNavigationRequestCount: Int? = null
) {
    BoxWithConstraints(Modifier.fillMaxSize()) {
        if (!showSystemNavigation) {
            HavnScaffold(
                destination = destination,
                authState = authState,
                showBottomBar = false,
                useSafeDrawingInsets = false,
                onDestinationSelected = onDestinationSelected,
                onTabSelected = onTabSelected,
                onLogout = onLogout,
                propertiesViewModel = propertiesViewModel,
                openHousesViewModel = openHousesViewModel,
                leadsViewModel = leadsViewModel,
                clientsViewModel = clientsViewModel,
                followUpsViewModel = followUpsViewModel,
                sellerReportsViewModel = sellerReportsViewModel,
                tasksViewModel = tasksViewModel,
                attachmentsViewModel = attachmentsViewModel,
                agencyViewModel = agencyViewModel,
                photoPicker = photoPicker,
                filePicker = filePicker,
                authRepository = authRepository,
                languageRepository = languageRepository,
                unitPreferencesRepository = unitPreferencesRepository,
                kioskSecurityRepository = kioskSecurityRepository,
                mcpApiKeyRepository = mcpApiKeyRepository,
                themeManager = themeManager,
                notificationRepository = notificationRepository,
                billingService = billingService,
                analyticsAiService = analyticsAiService,
                externalRootNavigationRequestCount = externalRootNavigationRequestCount
            )
        } else {
            HavnScaffold(
                destination = destination,
                authState = authState,
                showBottomBar = true,
                useSafeDrawingInsets = true,
                onDestinationSelected = onDestinationSelected,
                onTabSelected = onTabSelected,
                onLogout = onLogout,
                propertiesViewModel = propertiesViewModel,
                openHousesViewModel = openHousesViewModel,
                leadsViewModel = leadsViewModel,
                clientsViewModel = clientsViewModel,
                followUpsViewModel = followUpsViewModel,
                sellerReportsViewModel = sellerReportsViewModel,
                tasksViewModel = tasksViewModel,
                attachmentsViewModel = attachmentsViewModel,
                agencyViewModel = agencyViewModel,
                photoPicker = photoPicker,
                filePicker = filePicker,
                authRepository = authRepository,
                languageRepository = languageRepository,
                unitPreferencesRepository = unitPreferencesRepository,
                kioskSecurityRepository = kioskSecurityRepository,
                mcpApiKeyRepository = mcpApiKeyRepository,
                themeManager = themeManager,
                notificationRepository = notificationRepository,
                billingService = billingService,
                analyticsAiService = analyticsAiService,
                externalRootNavigationRequestCount = externalRootNavigationRequestCount
            )
        }
    }
}

private data class HavnSystemNavigationItem(
    val destination: HavnDestination,
    val label: String? = null
)

private val havnSystemNavigationItems = listOf(
    HavnSystemNavigationItem(HavnDestination.Dashboard),
    HavnSystemNavigationItem(HavnDestination.Properties),
    HavnSystemNavigationItem(HavnDestination.Clients),
    HavnSystemNavigationItem(HavnDestination.OpenHouses),
    HavnSystemNavigationItem(HavnDestination.Leads)
)

private val HavnDestination.navigationIcon: HavnIconKey
    get() = when (this) {
        HavnDestination.Dashboard -> HavnIconKey.Calendar
        HavnDestination.Properties -> HavnIconKey.Home
        HavnDestination.OpenHouses -> HavnIconKey.CalendarClock
        HavnDestination.Clients -> HavnIconKey.ContactCard
        HavnDestination.Leads -> HavnIconKey.Leads
        HavnDestination.Reports -> HavnIconKey.Reports
        HavnDestination.Tasks -> HavnIconKey.Check
        HavnDestination.Analytics -> HavnIconKey.Chart
        HavnDestination.Agency -> HavnIconKey.Building
        HavnDestination.Settings -> HavnIconKey.Settings
        else -> icon
    }

@Composable
private fun HavnScaffold(
    destination: HavnDestination,
    authState: AuthState,
    showBottomBar: Boolean,
    useSafeDrawingInsets: Boolean,
    onDestinationSelected: (HavnDestination) -> Unit,
    onTabSelected: (HavnDestination) -> Unit,
    onLogout: () -> Unit,
    propertiesViewModel: PropertiesViewModel,
    openHousesViewModel: OpenHousesViewModel,
    leadsViewModel: LeadsViewModel,
    clientsViewModel: ClientsViewModel,
    followUpsViewModel: FollowUpsViewModel,
    sellerReportsViewModel: SellerReportsViewModel,
    tasksViewModel: TasksViewModel,
    attachmentsViewModel: AttachmentsViewModel,
    agencyViewModel: AgencyViewModel,
    photoPicker: HavnPhotoPicker,
    filePicker: HavnFilePicker,
    authRepository: AuthRepository,
    languageRepository: com.havn.app.core.localization.HavnLanguageRepository,
    unitPreferencesRepository: com.havn.app.core.settings.HavnUnitPreferencesRepository,
    kioskSecurityRepository: com.havn.app.core.settings.HavnKioskSecurityRepository,
    mcpApiKeyRepository: McpApiKeyRepository,
    themeManager: HavnThemeManager,
    notificationRepository: NotificationRepository,
    billingService: HavnBillingService,
    analyticsAiService: com.havn.app.features.analytics.domain.AnalyticsAiService,
    externalRootNavigationRequestCount: Int? = null
) {
    val openHousesState by openHousesViewModel.uiState.collectAsState()
    val propertiesState by propertiesViewModel.uiState.collectAsState()
    val clientsState by clientsViewModel.uiState.collectAsState()
    val leadsState by leadsViewModel.uiState.collectAsState()
    val agencyState by agencyViewModel.uiState.collectAsState()
    var leadReturnOpeningId by remember { mutableStateOf<String?>(null) }
    var contactReturnClientId by remember { mutableStateOf<String?>(null) }
    var contactReturnLabel by remember { mutableStateOf<String?>(null) }
    var openingReturnToToday by remember { mutableStateOf(false) }
    var propertyReturnToToday by remember { mutableStateOf(false) }
    var openSettingsPurchase by remember { mutableStateOf(false) }
    var openSettingsPurchaseBackToToday by remember { mutableStateOf(false) }
    var shownFreeEmptyUpgradePromptForUserId by rememberSaveable { mutableStateOf<String?>(null) }
    var agentProfileRefreshToken by remember { mutableStateOf(0) }
    var pendingRootDestination by remember { mutableStateOf<HavnDestination?>(null) }
    var rootTabReselectEvents by remember { mutableStateOf<Map<HavnDestination, Int>>(emptyMap()) }
    val pendingDeepLink by HavnPushNotifications.deepLinks.collectAsState()
    val signedInUserId = (authState as? AuthState.LoggedIn)?.user?.id
    val canUseProModules = agencyState.entitlement.isProAgent
    val canUseAnalytics = agencyState.entitlement.canUseAdvancedAnalytics
    val canUseReports = agencyState.entitlement.canUseSellerReports
    val canUseTasks = HavnPlans.limitsFor(agencyState.entitlement.tier).hasTasks
    val appStrings = LocalHavnStrings.current
    val canUseFiles = agencyState.entitlement.canUseFiles
    fun rootDestinationReady(nextDestination: HavnDestination): Boolean = when (nextDestination) {
        HavnDestination.Properties -> propertiesState.hasLoadedInitialPage
        HavnDestination.Clients -> clientsState.hasLoadedInitialPage
        HavnDestination.OpenHouses -> openHousesState.hasLoadedInitialPage && openHousesState.hasLoadedPropertyOptions
        HavnDestination.Leads -> leadsState.hasLoadedInitialPage
        else -> true
    }
    fun requestRootRefresh(nextDestination: HavnDestination) {
        when (nextDestination) {
            HavnDestination.Properties -> propertiesViewModel.refresh()
            HavnDestination.Clients -> clientsViewModel.refresh()
            HavnDestination.OpenHouses -> openHousesViewModel.refresh()
            HavnDestination.Leads -> leadsViewModel.refresh()
            else -> Unit
        }
    }
    fun openRootDestination(nextDestination: HavnDestination) {
        leadReturnOpeningId = null
        contactReturnClientId = null
        contactReturnLabel = null
        openingReturnToToday = false
        propertyReturnToToday = false
        openSettingsPurchase = false
        openSettingsPurchaseBackToToday = false
        pendingRootDestination = null
        onTabSelected(nextDestination)
    }
    val rootTabSelected: (HavnDestination) -> Unit = { nextDestination ->
        val canOpenDestination = when (nextDestination) {
            HavnDestination.Tasks -> canUseTasks
            HavnDestination.Reports -> canUseReports
            HavnDestination.Analytics -> canUseAnalytics
            else -> true
        }
        if (!canOpenDestination) {
            propertyReturnToToday = false
            openSettingsPurchase = true
            openSettingsPurchaseBackToToday = false
            onTabSelected(HavnDestination.Settings)
        } else if (nextDestination == HavnDestination.Files && !canUseFiles) {
            propertyReturnToToday = false
            openSettingsPurchase = true
            openSettingsPurchaseBackToToday = false
            onTabSelected(HavnDestination.Settings)
        } else if (nextDestination == destination) {
            rootTabReselectEvents = rootTabReselectEvents + (nextDestination to ((rootTabReselectEvents[nextDestination] ?: 0) + 1))
        } else if (!rootDestinationReady(nextDestination)) {
            pendingRootDestination = nextDestination
            requestRootRefresh(nextDestination)
        } else {
            openRootDestination(nextDestination)
        }
    }
    LaunchedEffect(
        pendingRootDestination,
        propertiesState.hasLoadedInitialPage,
        clientsState.hasLoadedInitialPage,
        openHousesState.hasLoadedInitialPage,
        openHousesState.hasLoadedPropertyOptions,
        leadsState.hasLoadedInitialPage
    ) {
        val pending = pendingRootDestination ?: return@LaunchedEffect
        if (rootDestinationReady(pending)) {
            openRootDestination(pending)
        }
    }
    LaunchedEffect(externalRootNavigationRequestCount) {
        val requestCount = externalRootNavigationRequestCount ?: return@LaunchedEffect
        if (requestCount > 0) {
            rootTabReselectEvents = rootTabReselectEvents + (destination to ((rootTabReselectEvents[destination] ?: 0) + 1))
        }
    }
    LaunchedEffect(pendingDeepLink) {
        val link = HavnPushNotifications.consumePendingDeepLink() ?: return@LaunchedEffect
        routeHavnDeepLink(
            link = link,
            propertiesViewModel = propertiesViewModel,
            openHousesViewModel = openHousesViewModel,
            leadsViewModel = leadsViewModel,
            sellerReportsViewModel = sellerReportsViewModel,
            onDestinationSelected = onDestinationSelected,
            onOpenSubscription = {
                openSettingsPurchase = true
                openSettingsPurchaseBackToToday = false
                onDestinationSelected(HavnDestination.Settings)
            }
        )
    }
    LaunchedEffect(
        signedInUserId,
        agencyState.hasLoadedEntitlement,
        agencyState.entitlement.tier,
        propertiesState.hasLoadedInitialPage,
        propertiesState.totalPropertyCount,
        clientsState.hasLoadedInitialPage,
        clientsState.clients.size,
        clientsState.searchQuery
    ) {
        val userId = signedInUserId ?: return@LaunchedEffect
        val shouldShowUpgradePrompt =
            agencyState.hasLoadedEntitlement &&
                agencyState.entitlement.tier == HavnSubscriptionTier.Free &&
                propertiesState.hasLoadedInitialPage &&
                clientsState.hasLoadedInitialPage &&
                propertiesState.totalPropertyCount == 0 &&
                clientsState.clients.isEmpty() &&
                clientsState.searchQuery.isBlank() &&
                shownFreeEmptyUpgradePromptForUserId != userId
        if (shouldShowUpgradePrompt) {
            shownFreeEmptyUpgradePromptForUserId = userId
            leadReturnOpeningId = null
            contactReturnClientId = null
            contactReturnLabel = null
            openingReturnToToday = false
            propertyReturnToToday = false
            openSettingsPurchase = true
            openSettingsPurchaseBackToToday = true
            onDestinationSelected(HavnDestination.Settings)
        }
    }
    val effectiveShowBottomBar = showBottomBar && !openHousesState.mode.usesKioskImmersiveChrome()

    BoxWithConstraints(Modifier.fillMaxSize()) {
        val useWideSideMenu = effectiveShowBottomBar &&
            ((havnIsWebShell && maxWidth >= 1280.dp) || (havnIsTabletDevice() && maxWidth >= 820.dp))
        val useNavigationRail = effectiveShowBottomBar &&
            !useWideSideMenu &&
            ((havnIsWebShell && maxWidth >= 700.dp) || (havnIsTabletDevice() && maxWidth >= 600.dp))
        val useFloatingBottomToolbar = effectiveShowBottomBar && !useWideSideMenu && !useNavigationRail
        Scaffold(
            contentWindowInsets = when {
                !useSafeDrawingInsets -> WindowInsets(0.dp)
                havnUsesRootSafeDrawingInsets -> WindowInsets.safeDrawing
                havnUsesRootStatusBarInsets -> WindowInsets.statusBars
                else -> WindowInsets(0.dp)
            },
            containerColor = LocalHavnThemeTokens.current.background
        ) { paddingValues ->
            Box(Modifier.fillMaxSize()) {
                Row(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(paddingValues)
                ) {
                    if (useWideSideMenu) {
                        HavnWideSideMenu(
                            selected = destination,
                            showAgency = agencyState.entitlement.isProAgent,
                            showProModules = canUseProModules,
                            showTasks = canUseTasks,
                            showAnalytics = canUseAnalytics,
                            authState = authState,
                            authRepository = authRepository,
                            profileRefreshToken = agentProfileRefreshToken,
                            planLabel = agencyState.entitlement.tier.displayLabel,
                            onDestinationSelected = rootTabSelected,
                            onUpgradePlan = {
                                leadReturnOpeningId = null
                                contactReturnClientId = null
                                contactReturnLabel = null
                                openingReturnToToday = false
                                propertyReturnToToday = false
                                openSettingsPurchase = true
                                openSettingsPurchaseBackToToday = false
                                onDestinationSelected(HavnDestination.Settings)
                            }
                        )
                    } else if (useNavigationRail) {
                        HavnNavigationRail(
                            selected = destination,
                            showAgency = agencyState.entitlement.isProAgent,
                            showProModules = canUseProModules,
                            showTasks = canUseTasks,
                            showAnalytics = canUseAnalytics,
                            onDestinationSelected = rootTabSelected
                        )
                    }
                    Box(modifier = Modifier.fillMaxSize()) {
                        HavnPushNavigation(
                            targetState = destination,
                            depthFor = HavnDestination::navigationDepth,
                            modifier = Modifier.fillMaxSize()
                        ) { visibleDestination ->
                            HavnScreen(
                                visibleDestination,
                                onLogout,
                                propertiesViewModel,
                                openHousesViewModel,
                                leadsViewModel,
                                clientsViewModel,
                                followUpsViewModel,
                                sellerReportsViewModel,
                                tasksViewModel,
                                attachmentsViewModel,
                                agencyViewModel,
                                photoPicker,
                                filePicker,
                                authRepository,
                                languageRepository,
                                unitPreferencesRepository,
                                kioskSecurityRepository,
                                mcpApiKeyRepository,
                                themeManager,
                                notificationRepository,
                                billingService,
                                analyticsAiService,
                                canUseProModules = canUseProModules,
                                agentProfileRefreshToken = agentProfileRefreshToken,
                                onAgentProfileChanged = { agentProfileRefreshToken++ },
                                leadReturnOpeningId = leadReturnOpeningId,
                                onLeadReturnOpeningChanged = { leadReturnOpeningId = it },
                                contactReturnClientId = contactReturnClientId,
                                contactReturnLabel = contactReturnLabel,
                                onContactReturnChanged = { clientId, label ->
                                    contactReturnClientId = clientId
                                    contactReturnLabel = label
                                },
                                openingReturnToToday = openingReturnToToday,
                                onOpeningReturnToTodayChanged = { openingReturnToToday = it },
                                propertyReturnToToday = propertyReturnToToday,
                                onPropertyReturnToTodayChanged = { propertyReturnToToday = it },
                                onDestinationSelected = onDestinationSelected,
                                showDashboardHeaderActions = !useNavigationRail && !useWideSideMenu,
                                openSettingsPurchase = openSettingsPurchase,
                                openSettingsPurchaseBackToToday = openSettingsPurchaseBackToToday,
                                onSettingsPurchaseConsumed = { openSettingsPurchase = false },
                                rootTabReselectEvents = rootTabReselectEvents,
                                onOpenSubscription = {
                                    leadReturnOpeningId = null
                                    contactReturnClientId = null
                                    contactReturnLabel = null
                                    openingReturnToToday = false
                                    propertyReturnToToday = false
                                    openSettingsPurchase = true
                                    openSettingsPurchaseBackToToday = false
                                    onDestinationSelected(HavnDestination.Settings)
                                }
                            )
                        }
                    }
                }
                if (useFloatingBottomToolbar) {
                    HavnBottomNavigation(
                        selected = destination,
                        onDestinationSelected = rootTabSelected,
                        modifier = Modifier.align(Alignment.BottomCenter)
                    )
                }
            }
        }
    }
}

@Composable
private fun HavnBottomNavigation(
    selected: HavnDestination,
    onDestinationSelected: (HavnDestination) -> Unit,
    modifier: Modifier = Modifier
) {
    val strings = LocalHavnStrings.current
    val colors = LocalHavnThemeTokens.current
    val items = remember { havnSystemNavigationItems }
    Box(
        modifier = modifier
            .fillMaxWidth()
            .navigationBarsPadding()
            .padding(start = 16.dp, end = 16.dp, top = 4.dp, bottom = 12.dp),
        contentAlignment = Alignment.Center
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth(0.92f)
                .widthIn(max = 420.dp)
                .height(64.dp)
                .clip(RoundedCornerShape(32.dp))
                .background(colors.surface)
                .border(BorderStroke(1.dp, colors.border.copy(alpha = 0.56f)), RoundedCornerShape(32.dp))
                .padding(horizontal = 8.dp, vertical = 6.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            items.forEach { item ->
                val destination = item.destination
                HavnBottomToolbarItem(
                    selected = selected == destination,
                    icon = destination.navigationIcon,
                    contentDescription = destination.localizedTitle(strings),
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxHeight(),
                    onClick = { onDestinationSelected(destination) }
                )
            }
        }
    }
}

@Composable
private fun HavnBottomToolbarItem(
    selected: Boolean,
    icon: HavnIconKey,
    contentDescription: String,
    modifier: Modifier = Modifier,
    onClick: () -> Unit
) {
    val colors = LocalHavnThemeTokens.current
    val foreground = if (selected) colors.primaryAccent else colors.secondaryText
    Box(
        modifier = modifier,
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier
                .size(48.dp)
                .clip(CircleShape)
                .background(
                    if (selected) colors.primaryAccent.copy(alpha = 0.14f) else Color.Transparent
                )
                .clickable(onClick = onClick),
            contentAlignment = Alignment.Center
        ) {
            HavnIcon(
                icon = icon,
                contentDescription = contentDescription,
                modifier = Modifier.size(24.dp),
                tint = foreground
            )
        }
    }
}

@Composable
private fun HavnNavigationRail(
    selected: HavnDestination,
    showAgency: Boolean,
    showProModules: Boolean,
    showTasks: Boolean,
    showAnalytics: Boolean,
    onDestinationSelected: (HavnDestination) -> Unit
) {
    val strings = LocalHavnStrings.current
    val colors = LocalHavnThemeTokens.current
    val items = remember(showAgency, showProModules, showTasks, showAnalytics) {
        buildSideMenuDestinations(showAgency = showAgency, showProModules = showProModules, showTasks = showTasks, showAnalytics = showAnalytics)
    }
    NavigationRail(
        modifier = Modifier
            .padding(start = 12.dp, top = 12.dp, bottom = 12.dp)
            .width(84.dp)
            .fillMaxHeight()
            .clip(RoundedCornerShape(34.dp))
            .border(BorderStroke(1.dp, colors.border.copy(alpha = 0.56f)), RoundedCornerShape(34.dp)),
        containerColor = colors.surface.copy(alpha = 0.96f),
        contentColor = colors.primaryText
    ) {
        Spacer(Modifier.height(HavnSpacing.md))
        items.forEach { item ->
            val destination = item.destination
            val label = item.label(strings)
            HavnNavigationTile(
                selected = selected == destination,
                label = label,
                icon = item.icon,
                contentDescription = destination.localizedTitle(strings),
                modifier = Modifier
                    .width(70.dp)
                    .height(64.dp)
                    .padding(horizontal = 3.dp, vertical = 2.dp),
                onClick = { onDestinationSelected(destination) }
            )
            Spacer(Modifier.height(4.dp))
        }
    }
}

@Composable
private fun HavnNavigationTile(
    selected: Boolean,
    label: String,
    icon: HavnIconKey,
    contentDescription: String,
    modifier: Modifier = Modifier,
    onClick: () -> Unit
) {
    val colors = LocalHavnThemeTokens.current
    val shape = RoundedCornerShape(26.dp)
    val foreground = if (selected) colors.primaryAccent else colors.secondaryText
    Column(
        modifier = modifier
            .clip(shape)
            .clickable(onClick = onClick)
            .padding(horizontal = 4.dp, vertical = 5.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        HavnIcon(
            icon = icon,
            contentDescription = contentDescription,
            modifier = Modifier.size(22.dp),
            tint = foreground
        )
        Spacer(Modifier.height(3.dp))
        Text(
            label,
            color = foreground,
            fontSize = 11.sp,
            lineHeight = 12.sp,
            fontWeight = if (selected) FontWeight.Bold else FontWeight.SemiBold,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
private fun HavnWideSideMenu(
    selected: HavnDestination,
    showAgency: Boolean,
    showProModules: Boolean,
    showTasks: Boolean,
    showAnalytics: Boolean,
    authState: AuthState,
    authRepository: AuthRepository,
    profileRefreshToken: Int,
    planLabel: String,
    onDestinationSelected: (HavnDestination) -> Unit,
    onUpgradePlan: () -> Unit
) {
    val strings = LocalHavnStrings.current
    val colors = LocalHavnThemeTokens.current
    val mainItems = remember(showAgency, showProModules, showTasks, showAnalytics) {
        buildSideMenuDestinations(showAgency = showAgency, showProModules = showProModules, showTasks = showTasks, showAnalytics = showAnalytics)
    }
    val userId = (authState as? AuthState.LoggedIn)?.user?.id
    var profileName by remember(userId) { mutableStateOf<String?>(null) }
    var profileAvatarDataUrl by remember(userId) { mutableStateOf<String?>(null) }

    LaunchedEffect(userId, profileRefreshToken) {
        profileName = null
        profileAvatarDataUrl = null
        if (userId != null) {
            authRepository.agentProfile(userId)
                .onSuccess { profile ->
                    profileName = profile.fullName.takeIf { it.isNotBlank() }
                    profileAvatarDataUrl = profile.avatarDataUrl
                }
        }
    }

    val fallbackUserName = when (authState) {
        is AuthState.LoggedIn -> authState.user.email
            ?.substringBefore("@")
            ?.replace(".", " ")
            ?.split(" ")
            ?.filter { it.isNotBlank() }
            ?.joinToString(" ") { segment -> segment.replaceFirstChar { it.uppercase() } }
            ?.takeIf { it.isNotBlank() }
            ?: "Agent"
        else -> "Agent"
    }
    val userName = profileName ?: fallbackUserName

    val liquidSidebar = havnUsesLiquidSidebar
    val materialSidebar = havnUsesMaterialSidebar
    val materialColors = MaterialTheme.colorScheme
    val sidebarWidth = when {
        materialSidebar -> 360.dp
        !havnIsWebShell && havnIsTabletDevice() -> 288.dp
        else -> 252.dp
    }
    val sidebarShape = if (liquidSidebar) {
        RoundedCornerShape(topEnd = 30.dp, bottomEnd = 30.dp)
    } else {
        RoundedCornerShape(0.dp)
    }
    val sidebarBorderAlpha = when {
        materialSidebar -> 0.18f
        liquidSidebar -> 0.34f
        else -> 0.64f
    }
    val sidebarHorizontalPadding = when {
        materialSidebar -> 12.dp
        liquidSidebar -> 18.dp
        else -> HavnSpacing.md
    }

    BoxWithConstraints(
        modifier = Modifier
            .width(sidebarWidth)
            .fillMaxHeight()
            .clip(sidebarShape)
            .background(
                Brush.verticalGradient(
                    if (liquidSidebar) {
                        listOf(
                            colors.primaryText.copy(alpha = 0.08f),
                            colors.surface.copy(alpha = 0.76f),
                            colors.background.copy(alpha = 0.64f)
                        )
                    } else if (materialSidebar) {
                        listOf(
                            materialColors.surface.copy(alpha = 1f),
                            materialColors.surface.copy(alpha = 1f)
                        )
                    } else {
                        listOf(
                            colors.surface.copy(alpha = 0.98f),
                            colors.background.copy(alpha = 0.98f)
                        )
                    }
                )
            )
            .border(BorderStroke(1.dp, colors.border.copy(alpha = sidebarBorderAlpha)), sidebarShape)
            .padding(horizontal = sidebarHorizontalPadding, vertical = if (materialSidebar) 12.dp else HavnSpacing.lg)
    ) {
        val compact = if (materialSidebar) maxHeight < 900.dp else maxHeight < 760.dp
        val veryCompact = if (materialSidebar) maxHeight < 720.dp else maxHeight < 620.dp
        val itemGap = when {
            materialSidebar && veryCompact -> 1.dp
            materialSidebar && compact -> 2.dp
            materialSidebar -> 3.dp
            veryCompact -> 4.dp
            compact -> 5.dp
            else -> 7.dp
        }
        val showProfileCard = maxHeight >= 500.dp
        val showSupport = maxHeight >= 980.dp
        val logoBottomGap = if (veryCompact) HavnSpacing.xs else if (compact) HavnSpacing.sm else 18.dp
        val profileTopGap = if (veryCompact) HavnSpacing.xs else if (compact) HavnSpacing.sm else HavnSpacing.md
        val itemCount = mainItems.size.coerceAtLeast(1)
        val materialTargetItemHeight = when {
            veryCompact -> 46.dp
            compact -> 50.dp
            else -> 56.dp
        }
        val measuredMaterialItemHeight = run {
            val logoHeight = if (compact) 40.dp else 48.dp
            val profileHeight = if (!showProfileCard) 0.dp else if (compact) 70.dp else 172.dp
            val profileGap = if (showProfileCard) profileTopGap else 0.dp
            val supportHeight = if (showSupport) 80.dp + HavnSpacing.lg else 0.dp
            val interItemGaps = itemGap * (itemCount - 1).toFloat()
            val availableForItems = maxHeight - logoHeight - logoBottomGap - profileGap - profileHeight - supportHeight - interItemGaps
            (availableForItems / itemCount.toFloat()).coerceIn(40.dp, materialTargetItemHeight)
        }
        val itemHeight = when {
            materialSidebar -> measuredMaterialItemHeight
            veryCompact -> 42.dp
            compact -> 44.dp
            else -> 48.dp
        }
        val navigationScrollState = rememberScrollState()
        Column(Modifier.fillMaxSize()) {
            HavnSidebarLogo(compact = compact)
            Spacer(Modifier.height(logoBottomGap))

            Column(
                modifier = Modifier
                    .weight(1f)
                    .verticalScroll(navigationScrollState),
                verticalArrangement = Arrangement.spacedBy(itemGap)
            ) {
                mainItems.forEach { item ->
                    val itemDestination = item.destination
                    HavnWideSideMenuRow(
                        icon = item.icon,
                        label = item.label(strings),
                        selected = selected == itemDestination,
                        enabled = item.enabled,
                        badge = item.badge,
                        height = itemHeight,
                        onClick = {
                            onDestinationSelected(itemDestination)
                        }
                    )
                }
            }

            if (showProfileCard) {
                Spacer(Modifier.height(profileTopGap))
                HavnSidebarProfileCard(
                    userName = userName,
                    avatarDataUrl = profileAvatarDataUrl,
                    planLabel = planLabel,
                    compact = compact,
                    onUpgradePlan = onUpgradePlan
                )
            }
            if (showSupport) {
                Spacer(Modifier.height(HavnSpacing.lg))
                HavnSidebarSupport()
            }
        }
    }
}

private fun buildSideMenuDestinations(
    showAgency: Boolean,
    showProModules: Boolean,
    showTasks: Boolean,
    showAnalytics: Boolean,
    includeSettings: Boolean = true
): List<SideMenuItem.Destination> = buildList {
    add(SideMenuItem.Destination(HavnDestination.Dashboard))
    add(SideMenuItem.Destination(HavnDestination.Properties))
    add(SideMenuItem.Destination(HavnDestination.Clients))
    add(SideMenuItem.Destination(HavnDestination.OpenHouses))
    add(SideMenuItem.Destination(HavnDestination.Leads))
    if (showTasks) {
        add(SideMenuItem.Destination(HavnDestination.Tasks))
    }
    if (showProModules) {
        add(SideMenuItem.Destination(HavnDestination.Reports))
    }
    if (showAnalytics) {
        add(SideMenuItem.Destination(HavnDestination.Analytics))
    }
    if (showAgency) {
        add(SideMenuItem.Destination(HavnDestination.Agency))
    }
    if (includeSettings) {
        add(SideMenuItem.Destination(HavnDestination.Settings))
    }
}

@Composable
private fun HavnSidebarLogo(compact: Boolean) {
    val colors = LocalHavnThemeTokens.current
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            painter = painterResource(Res.drawable.havn_auth_logo),
            contentDescription = "HAVN",
            modifier = Modifier.size(if (compact) 40.dp else 48.dp),
            contentScale = ContentScale.Fit
        )
        Spacer(Modifier.width(HavnSpacing.sm))
        Column {
            Text(
                "HAVN",
                color = colors.primaryText,
                fontSize = if (compact) 24.sp else 28.sp,
                fontWeight = FontWeight.SemiBold,
                letterSpacing = 3.sp
            )
            Text(
                "AI Real Estate",
                color = colors.primaryAccent,
                style = MaterialTheme.typography.labelSmall,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
private fun HavnWideSideMenuRow(
    icon: HavnIconKey,
    label: String,
    selected: Boolean,
    enabled: Boolean,
    badge: String? = null,
    height: androidx.compose.ui.unit.Dp = 46.dp,
    onClick: () -> Unit
) {
    val colors = LocalHavnThemeTokens.current
    val liquidSidebar = havnUsesLiquidSidebar
    val materialSidebar = havnUsesMaterialSidebar
    val materialColors = MaterialTheme.colorScheme
    val shape = RoundedCornerShape(
        when {
            materialSidebar -> 28.dp
            liquidSidebar -> 18.dp
            else -> 8.dp
        }
    )
    val selectedBackground = when {
        materialSidebar -> Brush.horizontalGradient(
            listOf(materialColors.secondaryContainer, materialColors.secondaryContainer)
        )
        liquidSidebar -> Brush.horizontalGradient(
            listOf(
                colors.primaryText.copy(alpha = 0.13f),
                colors.primaryAccent.copy(alpha = 0.2f),
                colors.card.copy(alpha = 0.28f)
            )
        )
        else -> Brush.horizontalGradient(
            listOf(colors.primaryAccent.copy(alpha = 0.18f), colors.card.copy(alpha = 0.18f))
        )
    }
    val idleBackground = Brush.horizontalGradient(
        listOf(colors.surface.copy(alpha = 0f), colors.surface.copy(alpha = 0f))
    )
    val foreground = when {
        selected && materialSidebar -> materialColors.onSecondaryContainer
        selected && liquidSidebar -> colors.secondaryAccent
        selected -> colors.primaryAccent
        materialSidebar -> materialColors.onSurfaceVariant
        else -> colors.secondaryText
    }
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(height)
            .clip(shape)
            .background(if (selected) selectedBackground else idleBackground)
            .border(
                BorderStroke(
                    1.dp,
                    if (selected) {
                        when {
                            materialSidebar -> Color.Transparent
                            liquidSidebar -> colors.secondaryAccent.copy(alpha = 0.5f)
                            else -> colors.primaryAccent.copy(alpha = 0.2f)
                        }
                    } else {
                        Color.Transparent
                    }
                ),
                shape
            )
            .then(if (enabled) Modifier.clickable(onClick = onClick) else Modifier)
            .alpha(if (enabled) 1f else 0.54f)
            .padding(horizontal = HavnSpacing.md),
        verticalAlignment = Alignment.CenterVertically
    ) {
        HavnIcon(
            icon = icon,
            contentDescription = label,
            modifier = Modifier.size(if (materialSidebar) 24.dp else 22.dp),
            tint = foreground
        )
        Spacer(Modifier.width(HavnSpacing.md))
        Text(
            label,
            modifier = Modifier.weight(1f),
            color = foreground,
            style = if (materialSidebar) MaterialTheme.typography.labelLarge else MaterialTheme.typography.bodyLarge,
            fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Medium,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        if (badge != null) {
            Box(
                modifier = Modifier
                    .clip(CircleShape)
                    .background(colors.cold.copy(alpha = 0.72f))
                    .padding(horizontal = 10.dp, vertical = 3.dp),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    badge,
                    color = colors.primaryText,
                    style = MaterialTheme.typography.labelSmall,
                    fontWeight = FontWeight.Bold
                )
            }
        }
    }
}

@Composable
private fun HavnSidebarProfileCard(
    userName: String,
    avatarDataUrl: String?,
    planLabel: String,
    compact: Boolean,
    onUpgradePlan: () -> Unit
) {
    val colors = LocalHavnThemeTokens.current
    val liquidSidebar = havnUsesLiquidSidebar
    val materialSidebar = havnUsesMaterialSidebar
    val materialColors = MaterialTheme.colorScheme
    val shape = RoundedCornerShape(
        when {
            materialSidebar -> 28.dp
            liquidSidebar -> 24.dp
            else -> 12.dp
        }
    )
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(shape)
            .background(
                Brush.verticalGradient(
                    if (liquidSidebar) {
                        listOf(
                            colors.primaryText.copy(alpha = 0.1f),
                            colors.card.copy(alpha = 0.58f),
                            colors.surface.copy(alpha = 0.46f)
                        )
                    } else if (materialSidebar) {
                        listOf(
                            materialColors.surfaceVariant.copy(alpha = 0.62f),
                            materialColors.surfaceVariant.copy(alpha = 0.62f)
                        )
                    } else {
                        listOf(colors.card.copy(alpha = 0.72f), colors.card.copy(alpha = 0.72f))
                    }
                )
            )
            .border(
                BorderStroke(
                    1.dp,
                    if (materialSidebar) materialColors.outline.copy(alpha = 0.18f) else colors.border.copy(alpha = if (liquidSidebar) 0.38f else 0.62f)
                ),
                shape
            )
            .padding(if (compact) HavnSpacing.sm else HavnSpacing.md)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Box(
                modifier = Modifier
                    .size(if (compact) 38.dp else 46.dp)
                    .clip(CircleShape)
                    .background(
                        Brush.linearGradient(
                            listOf(colors.primaryAccent.copy(alpha = 0.82f), colors.secondaryAccent.copy(alpha = 0.62f))
                        )
                    ),
                contentAlignment = Alignment.Center
            ) {
                val rendered = HavnDatabaseImage(
                    dataUrl = avatarDataUrl,
                    previewDataUrl = havnAgentAvatarPreviewSource(avatarDataUrl, if (compact) 64 else 96),
                    contentDescription = userName,
                    modifier = Modifier.fillMaxSize(),
                    contentScale = ContentScale.Crop
                )
                if (!rendered) {
                    HavnIcon(
                        icon = HavnIconKey.User,
                        contentDescription = null,
                        tint = if (materialSidebar) materialColors.onPrimary else colors.background,
                        modifier = Modifier.size(24.dp)
                    )
                }
            }
            Spacer(Modifier.width(HavnSpacing.sm))
            Column(Modifier.weight(1f)) {
                Text(
                    userName,
                    color = if (materialSidebar) materialColors.onSurface else colors.primaryText,
                    style = MaterialTheme.typography.bodyMedium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Row(verticalAlignment = Alignment.CenterVertically) {
                    HavnIcon(
                        icon = HavnIconKey.Star,
                        contentDescription = null,
                        tint = if (materialSidebar) materialColors.primary else colors.primaryAccent,
                        modifier = Modifier.size(15.dp)
                    )
                    Spacer(Modifier.width(HavnSpacing.xs))
                    Text(
                        planLabel,
                        color = if (materialSidebar) materialColors.primary else colors.primaryAccent,
                        style = MaterialTheme.typography.labelMedium
                    )
                }
            }
        }

        if (!compact) {
            Spacer(Modifier.height(HavnSpacing.lg))
            val upgradeShape = RoundedCornerShape(
                when {
                    materialSidebar -> 20.dp
                    liquidSidebar -> 18.dp
                    else -> 8.dp
                }
            )
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(upgradeShape)
                    .clickable(onClick = onUpgradePlan)
                    .background(
                        Brush.linearGradient(
                            if (liquidSidebar) {
                                listOf(colors.secondaryAccent.copy(alpha = 0.18f), colors.primaryText.copy(alpha = 0.06f))
                            } else if (materialSidebar) {
                                listOf(materialColors.primaryContainer, materialColors.primaryContainer)
                            } else {
                                listOf(colors.primaryAccent.copy(alpha = 0.14f), colors.surface.copy(alpha = 0.42f))
                            }
                        )
                    )
                    .border(
                        BorderStroke(
                            1.dp,
                            if (materialSidebar) Color.Transparent else colors.primaryAccent.copy(alpha = 0.28f)
                        ),
                        upgradeShape
                    )
                    .padding(HavnSpacing.md)
            ) {
                Text(
                    "$planLabel ${LocalHavnStrings.current.planSuffix}",
                    color = if (materialSidebar) materialColors.onPrimaryContainer else colors.primaryText,
                    style = MaterialTheme.typography.bodyMedium
                )
                Spacer(Modifier.height(HavnSpacing.xs))
                Text(
                    LocalHavnStrings.current.accountReady,
                    color = if (materialSidebar) materialColors.onPrimaryContainer.copy(alpha = 0.72f) else colors.secondaryText,
                    style = MaterialTheme.typography.labelMedium
                )
                Spacer(Modifier.height(HavnSpacing.md))
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(36.dp)
                        .clip(RoundedCornerShape(if (materialSidebar || liquidSidebar) 18.dp else 7.dp))
                        .background(
                            when {
                                materialSidebar -> materialColors.surface.copy(alpha = 0.72f)
                                liquidSidebar -> colors.primaryText.copy(alpha = 0.08f)
                                else -> Color.Transparent
                            }
                        )
                        .border(
                            BorderStroke(
                                1.dp,
                                if (materialSidebar) materialColors.primary.copy(alpha = 0.44f) else colors.primaryAccent.copy(alpha = 0.72f)
                            ),
                            RoundedCornerShape(if (materialSidebar || liquidSidebar) 18.dp else 7.dp)
                        ),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        LocalHavnStrings.current.upgradePlan,
                        color = if (materialSidebar) materialColors.primary else colors.primaryAccent,
                        style = MaterialTheme.typography.labelMedium
                    )
                }
            }
        }
    }
}

@Composable
private fun HavnSidebarSupport() {
    val colors = LocalHavnThemeTokens.current
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clickable {
                HavnExternalActions.openEmail(
                    to = "support@havnre.app",
                    subject = "HAVN support",
                    body = ""
                )
            }
            .padding(horizontal = HavnSpacing.md),
        verticalAlignment = Alignment.CenterVertically
    ) {
        HavnIcon(
            icon = HavnIconKey.Mail,
            contentDescription = null,
            modifier = Modifier.size(22.dp),
            tint = colors.secondaryText
        )
        Spacer(Modifier.width(HavnSpacing.md))
        Column {
            Text(LocalHavnStrings.current.needHelp, color = colors.primaryText, style = MaterialTheme.typography.labelMedium)
            Text(LocalHavnStrings.current.contactSupport, color = colors.primaryAccent, style = MaterialTheme.typography.labelMedium)
        }
    }
}

private sealed interface SideMenuItem {
    val icon: HavnIconKey
    val enabled: Boolean
    val badge: String?

    fun label(strings: com.havn.app.core.localization.HavnStrings): String

    data class Destination(
        val destination: HavnDestination,
        override val icon: HavnIconKey = destination.navigationIcon
    ) : SideMenuItem {
        override val enabled: Boolean = true
        override val badge: String? = null
        override fun label(strings: com.havn.app.core.localization.HavnStrings): String =
            destination.localizedShortLabel(strings)
    }

    data class Placeholder(
        private val title: String,
        override val icon: HavnIconKey,
        override val badge: String? = null
    ) : SideMenuItem {
        override val enabled: Boolean = false
        override fun label(strings: com.havn.app.core.localization.HavnStrings): String = title
    }
}

@Composable
private fun HavnScreen(
    destination: HavnDestination,
    onLogout: () -> Unit,
    propertiesViewModel: PropertiesViewModel,
    openHousesViewModel: OpenHousesViewModel,
    leadsViewModel: LeadsViewModel,
    clientsViewModel: ClientsViewModel,
    followUpsViewModel: FollowUpsViewModel,
    sellerReportsViewModel: SellerReportsViewModel,
    tasksViewModel: TasksViewModel,
    attachmentsViewModel: AttachmentsViewModel,
    agencyViewModel: AgencyViewModel,
    photoPicker: HavnPhotoPicker,
    filePicker: HavnFilePicker,
    authRepository: AuthRepository,
    languageRepository: com.havn.app.core.localization.HavnLanguageRepository,
    unitPreferencesRepository: com.havn.app.core.settings.HavnUnitPreferencesRepository,
    kioskSecurityRepository: com.havn.app.core.settings.HavnKioskSecurityRepository,
    mcpApiKeyRepository: McpApiKeyRepository,
    themeManager: HavnThemeManager,
    notificationRepository: NotificationRepository,
    billingService: HavnBillingService,
    analyticsAiService: com.havn.app.features.analytics.domain.AnalyticsAiService,
    canUseProModules: Boolean,
    agentProfileRefreshToken: Int,
    onAgentProfileChanged: () -> Unit,
    leadReturnOpeningId: String?,
    onLeadReturnOpeningChanged: (String?) -> Unit,
    contactReturnClientId: String?,
    contactReturnLabel: String?,
    onContactReturnChanged: (String?, String?) -> Unit,
    openingReturnToToday: Boolean,
    onOpeningReturnToTodayChanged: (Boolean) -> Unit,
    propertyReturnToToday: Boolean,
    onPropertyReturnToTodayChanged: (Boolean) -> Unit,
    onDestinationSelected: (HavnDestination) -> Unit,
    showDashboardHeaderActions: Boolean = true,
    openSettingsPurchase: Boolean = false,
    openSettingsPurchaseBackToToday: Boolean = false,
    onSettingsPurchaseConsumed: () -> Unit = {},
    rootTabReselectEvents: Map<HavnDestination, Int> = emptyMap(),
    onOpenSubscription: () -> Unit = {}
) {
    val agencyState by agencyViewModel.uiState.collectAsState()
    val currentAuthState by authRepository.authState.collectAsState()
    val sellerReportsState by sellerReportsViewModel.uiState.collectAsState()
    val tasksState by tasksViewModel.uiState.collectAsState()
    val attachmentsState by attachmentsViewModel.uiState.collectAsState()
    val clientsState by clientsViewModel.uiState.collectAsState()
    val currentUser = (currentAuthState as? AuthState.LoggedIn)?.user
    val shareRecipients = remember(clientsState.shareRecipientClients, clientsState.clients, agencyState.members) {
        (
            clientsState.shareRecipientClients.map { it.toAttachmentRecipient() } +
                clientsState.clients.map { it.toAttachmentRecipient() } +
                agencyState.members.mapNotNull { it.toAttachmentRecipient() }
            ).dedupeAttachmentRecipients()
    }
    var agentProfileName by remember(currentUser?.id) { mutableStateOf<String?>(null) }
    val canUseAiFollowUps = agencyState.entitlement.canUseAiFollowUps
    val canUseFiles = agencyState.entitlement.canUseFiles
    val canUseReports = agencyState.entitlement.canUseSellerReports
    val canUseAnalytics = agencyState.entitlement.canUseAdvancedAnalytics
    val canUseTasks = HavnPlans.limitsFor(agencyState.entitlement.tier).hasTasks
    val appStrings = LocalHavnStrings.current
    val deleteAccountUrl = deleteAccountUrl(LocalHavnLanguage.current)
    val phoneBackToToday: (() -> Unit)? = if (!havnIsWebShell && !havnIsTabletDevice()) {
        { onDestinationSelected(HavnDestination.Dashboard) }
    } else {
        null
    }
    var returnToTaskDetail by remember { mutableStateOf(false) }
    var taskContextReturnTaskId by remember { mutableStateOf<String?>(null) }
    var taskContextReturnLabel by remember { mutableStateOf<String?>(null) }
    var returnToSellerReport by remember { mutableStateOf(false) }
    val returnToTaskDetailAction: () -> Unit = {
        val taskId = taskContextReturnTaskId
        returnToTaskDetail = false
        taskContextReturnTaskId = null
        taskContextReturnLabel = null
        taskId?.let(tasksViewModel::openTask)
        onDestinationSelected(HavnDestination.Tasks)
    }
    val openLinkedTaskDetail: (String) -> Unit = { taskId ->
        returnToTaskDetail = false
        taskContextReturnTaskId = null
        taskContextReturnLabel = null
        tasksViewModel.openTask(taskId)
        onDestinationSelected(HavnDestination.Tasks)
    }
    val rememberTaskContextReturn: () -> Unit = {
        val taskId = tasksState.selectedTaskId
        val task = tasksState.tasks.firstOrNull { it.id == taskId }
        returnToTaskDetail = taskId != null
        taskContextReturnTaskId = taskId
        taskContextReturnLabel = task?.title?.takeIf { it.isNotBlank() } ?: appStrings.taskDetail
    }
    LaunchedEffect(destination) {
        if (destination == HavnDestination.Tasks ||
            destination == HavnDestination.Dashboard ||
            destination == HavnDestination.Reports ||
            destination == HavnDestination.Files ||
            destination == HavnDestination.Analytics ||
            destination == HavnDestination.Agency ||
            destination == HavnDestination.Settings
        ) {
            returnToTaskDetail = false
            taskContextReturnTaskId = null
            taskContextReturnLabel = null
        }
        if (destination != HavnDestination.Properties && destination != HavnDestination.Reports) {
            returnToSellerReport = false
        }
        if (destination != HavnDestination.Properties) {
            onPropertyReturnToTodayChanged(false)
        }
    }
    LaunchedEffect(currentUser?.id, agentProfileRefreshToken) {
        agentProfileName = null
        currentUser?.id?.let { userId ->
            authRepository.agentProfile(userId)
                .onSuccess { profile ->
                    agentProfileName = profile.fullName.takeIf { it.isNotBlank() }
                }
        }
    }
    val selectedAgency = agencyState.selectedAgency ?: agencyState.agency
    val agencyMemberName = agencyState.members
        .firstOrNull { it.agentId == currentUser?.id }
        ?.fullName
        ?.takeIf { it.isNotBlank() }
    val fallbackAgentName = currentUser?.email
        ?.substringBefore("@")
        ?.replace(".", " ")
        ?.split(" ")
        ?.filter { it.isNotBlank() }
        ?.joinToString(" ") { segment -> segment.replaceFirstChar { it.uppercase() } }
    val kioskBranding = KioskBranding(
        agencyName = selectedAgency?.name,
        agencyIconUrl = selectedAgency?.iconUrl,
        agentName = agentProfileName ?: agencyMemberName ?: fallbackAgentName,
        useAgencyBranding = agencyState.entitlement.isProAgent
    )

    when (destination) {
        HavnDestination.Auth,
        HavnDestination.Dashboard -> DashboardScreen(
            authRepository = authRepository,
            agencyViewModel = agencyViewModel,
            propertiesViewModel = propertiesViewModel,
            openHousesViewModel = openHousesViewModel,
            leadsViewModel = leadsViewModel,
            followUpsViewModel = followUpsViewModel,
            tasksViewModel = tasksViewModel,
            sellerReportsViewModel = sellerReportsViewModel,
            onOpenOpening = { openHouseId ->
                onContactReturnChanged(null, null)
                onOpeningReturnToTodayChanged(true)
                openHousesViewModel.openDetail(openHouseId)
                onDestinationSelected(HavnDestination.OpenHouses)
            },
            onViewProperty = { propertyId ->
                onPropertyReturnToTodayChanged(true)
                returnToSellerReport = false
                returnToTaskDetail = false
                propertiesViewModel.openProperty(propertyId)
                onDestinationSelected(HavnDestination.Properties)
            },
            onOpenLeads = {
                onLeadReturnOpeningChanged(null)
                onDestinationSelected(HavnDestination.Leads)
            },
            onOpenProperties = {
                onPropertyReturnToTodayChanged(false)
                onDestinationSelected(HavnDestination.Properties)
            },
            onOpenReports = {
                if (canUseReports) {
                    sellerReportsViewModel.openList()
                    onDestinationSelected(HavnDestination.Reports)
                } else {
                    onOpenSubscription()
                }
            },
            onOpenAnalytics = {
                if (canUseAnalytics) onDestinationSelected(HavnDestination.Analytics) else onOpenSubscription()
            },
            onOpenTasks = {
                if (canUseTasks) onDestinationSelected(HavnDestination.Tasks) else onOpenSubscription()
            },
            onOpenTask = { taskId ->
                if (canUseTasks) {
                    tasksViewModel.openTaskFromToday(taskId)
                    onDestinationSelected(HavnDestination.Tasks)
                } else {
                    onOpenSubscription()
                }
            },
            onAddProperty = {
                propertiesViewModel.startAdd()
                onDestinationSelected(HavnDestination.Properties)
            },
            onAddContact = {
                clientsViewModel.startAdd()
                onDestinationSelected(HavnDestination.Clients)
            },
            onOpenFiles = {
                if (canUseFiles) {
                    attachmentsViewModel.loadAllFiles()
                    onDestinationSelected(HavnDestination.Files)
                } else {
                    onOpenSubscription()
                }
            },
            onScheduleOpenHouse = { propertyId ->
                onContactReturnChanged(null, null)
                onOpeningReturnToTodayChanged(false)
                openHousesViewModel.showScheduleForProperty(propertyId)
                onDestinationSelected(HavnDestination.OpenHouses)
            },
            onOpenSettings = {
                onDestinationSelected(HavnDestination.Settings)
            },
            onOpenAgency = {
                onDestinationSelected(HavnDestination.Agency)
            },
            showHeaderActions = showDashboardHeaderActions,
            canUseFiles = canUseFiles,
            canUseTasks = canUseTasks,
            canUseReports = canUseReports,
            canUseAnalytics = canUseAnalytics,
            scrollToTopSignal = rootTabReselectEvents[HavnDestination.Dashboard] ?: 0
        )
        HavnDestination.Properties -> PropertiesScreen(
            viewModel = propertiesViewModel,
            followUpsViewModel = followUpsViewModel,
            photoPicker = photoPicker,
            filePicker = filePicker,
            propertyOpenings = openHousesViewModel.uiState.collectAsState().value.openHouses,
            attachmentsState = attachmentsState,
            generatingSellerReportPropertyId = sellerReportsState.generatingPropertyId,
            onOpenPropertyDetail = { propertyId ->
                onPropertyReturnToTodayChanged(false)
                openHousesViewModel.loadOpenHousesForProperty(propertyId)
                attachmentsViewModel.loadForProperty(propertyId)
            },
            onScheduleOpenHouse = { propertyId ->
                onContactReturnChanged(null, null)
                onOpeningReturnToTodayChanged(false)
                openHousesViewModel.showScheduleForProperty(propertyId)
                onDestinationSelected(HavnDestination.OpenHouses)
            },
            onOpenOpening = { openingId ->
                onContactReturnChanged(null, null)
                onOpeningReturnToTodayChanged(false)
                openHousesViewModel.openDetail(openingId)
                onDestinationSelected(HavnDestination.OpenHouses)
            },
            onOpenOwnerContact = { clientId ->
                onContactReturnChanged(null, null)
                onOpeningReturnToTodayChanged(false)
                clientsViewModel.openClient(clientId)
                onDestinationSelected(HavnDestination.Clients)
            },
            onCreateTask = { property ->
                if (agencyState.entitlement.isProAgent) {
                    tasksViewModel.startAddTask(
                        title = "Task for ${property.title}",
                        description = property.displayAddress,
                        propertyId = property.id,
                        contactId = property.ownerContactId
                    )
                    onDestinationSelected(HavnDestination.Tasks)
                } else {
                    onOpenSubscription()
                }
            },
            onCreateInquiryTask = { lead ->
                if (agencyState.entitlement.isProAgent) {
                    tasksViewModel.startAddTask(
                        title = "Follow up with ${lead.fullName}",
                        description = lead.sourceLine,
                        propertyId = lead.propertyId,
                        contactId = lead.contactId,
                        leadId = lead.id
                    )
                    onDestinationSelected(HavnDestination.Tasks)
                } else {
                    onOpenSubscription()
                }
            },
            onFollowUpCompleted = {
                propertiesViewModel.refreshSelectedInquiry()
                leadsViewModel.refresh()
            },
            canUseAiFollowUps = canUseAiFollowUps,
            onAiUpgradeRequired = onOpenSubscription,
            canGenerateSellerReport = agencyState.entitlement.isProAgent,
            onGenerateSellerReport = { propertyId ->
                if (agencyState.entitlement.isProAgent) {
                    sellerReportsViewModel.generatePropertyReport(propertyId)
                    onDestinationSelected(HavnDestination.Reports)
                } else {
                    onOpenSubscription()
                }
            },
            detailBackLabel = when {
                returnToSellerReport -> LocalHavnStrings.current.reportPreview
                returnToTaskDetail -> taskContextReturnLabel ?: LocalHavnStrings.current.taskDetail
                propertyReturnToToday -> LocalHavnStrings.current.navToday
                else -> null
            },
            onBackFromDetail = when {
                returnToSellerReport -> {
                    {
                        returnToSellerReport = false
                        propertiesViewModel.closeDetail()
                        onDestinationSelected(HavnDestination.Reports)
                    }
                }
                returnToTaskDetail -> {
                    {
                        propertiesViewModel.closeDetail()
                        returnToTaskDetailAction()
                    }
                }
                propertyReturnToToday -> {
                    {
                        onPropertyReturnToTodayChanged(false)
                        propertiesViewModel.closeDetail()
                        onDestinationSelected(HavnDestination.Dashboard)
                    }
                }
                else -> null
            },
            linkedTasks = tasksState.tasks,
            onOpenTask = openLinkedTaskDetail,
            onLoadAttachments = attachmentsViewModel::loadForProperty,
            onUploadAttachment = { property, file ->
                attachmentsViewModel.uploadForProperty(property.id, property.agencyId, file)
            },
            onOpenAttachment = attachmentsViewModel::openAttachment,
            onOpenPhotoAttachment = { photo -> HavnExternalActions.openUrl(photo.url) },
            onSendAttachmentEmail = attachmentsViewModel::sendSelectedEmail,
            onSendAttachmentSms = attachmentsViewModel::sendSelectedSms,
            shareRecipients = shareRecipients,
            isLoadingShareRecipients = clientsState.isLoadingShareRecipients,
            isLoadingMoreShareRecipients = clientsState.isLoadingMoreShareRecipients,
            hasMoreShareRecipients = clientsState.hasMoreShareRecipients,
            onOpenShareRecipients = clientsViewModel::openShareRecipientPicker,
            onShareRecipientQueryChange = clientsViewModel::updateShareRecipientQuery,
            onLoadMoreShareRecipients = clientsViewModel::loadMoreShareRecipients,
            onDeleteAttachment = attachmentsViewModel::deleteAttachment,
            onDismissAttachmentError = attachmentsViewModel::clearError,
            onUpgradePlan = onOpenSubscription,
            canUseFiles = canUseFiles,
            scrollToTopSignal = rootTabReselectEvents[HavnDestination.Properties] ?: 0
        )
        HavnDestination.OpenHouses -> OpenHousesScreen(
            viewModel = openHousesViewModel,
            kioskPin = kioskSecurityRepository.pin.collectAsState().value,
            kioskBranding = kioskBranding,
            returnToToday = openingReturnToToday,
            returnToContactLabel = contactReturnLabel?.takeIf { contactReturnClientId != null },
            returnToTasks = returnToTaskDetail,
            returnToTasksLabel = taskContextReturnLabel,
            onReturnToToday = {
                onOpeningReturnToTodayChanged(false)
                onContactReturnChanged(null, null)
                onDestinationSelected(HavnDestination.Dashboard)
            },
            onReturnToProperty = { propertyId ->
                onOpeningReturnToTodayChanged(false)
                onContactReturnChanged(null, null)
                propertiesViewModel.openProperty(propertyId)
                onDestinationSelected(HavnDestination.Properties)
            },
            onReturnToContact = contactReturnClientId?.let { clientId ->
                {
                    onOpeningReturnToTodayChanged(false)
                    onContactReturnChanged(null, null)
                    clientsViewModel.openClient(clientId)
                    onDestinationSelected(HavnDestination.Clients)
                }
            } ?: {},
            onReturnToTasks = {
                onOpeningReturnToTodayChanged(false)
                onContactReturnChanged(null, null)
                openHousesViewModel.showList()
                returnToTaskDetailAction()
            },
            onOpenLead = { leadId, openingId ->
                onLeadReturnOpeningChanged(openingId)
                onContactReturnChanged(null, null)
                leadsViewModel.openLead(leadId)
                onDestinationSelected(HavnDestination.Leads)
            },
            linkedTasks = tasksState.tasks,
            onOpenTask = openLinkedTaskDetail,
            onUpgradePlan = onOpenSubscription,
            scrollToTopSignal = rootTabReselectEvents[HavnDestination.OpenHouses] ?: 0
        )
        HavnDestination.Clients -> ClientsScreen(
            viewModel = clientsViewModel,
            photoPicker = photoPicker,
            onCreateTask = { client ->
                if (agencyState.entitlement.isProAgent) {
                    tasksViewModel.startAddTask(
                        title = "Task for ${client.fullName}",
                        description = client.contactLine,
                        contactId = client.id
                    )
                    onDestinationSelected(HavnDestination.Tasks)
                } else {
                    onOpenSubscription()
                }
            },
            onOpenOpening = { openingId ->
                val clientsState = clientsViewModel.uiState.value
                val selectedClient = clientsState.selectedClient
                onContactReturnChanged(
                    clientsState.selectedClientId,
                    selectedClient?.fullName?.takeIf { it.isNotBlank() } ?: "Contact"
                )
                onOpeningReturnToTodayChanged(false)
                openHousesViewModel.openDetail(openingId)
                onDestinationSelected(HavnDestination.OpenHouses)
            },
            onOpenLead = { leadId ->
                val clientsState = clientsViewModel.uiState.value
                val selectedClient = clientsState.selectedClient
                onContactReturnChanged(
                    clientsState.selectedClientId,
                    selectedClient?.fullName?.takeIf { it.isNotBlank() } ?: "Contact"
                )
                leadsViewModel.openLead(leadId)
                onDestinationSelected(HavnDestination.Leads)
            },
            detailBackLabel = if (returnToTaskDetail) taskContextReturnLabel ?: LocalHavnStrings.current.taskDetail else null,
            onBackFromDetail = if (returnToTaskDetail) {
                {
                    clientsViewModel.openList()
                    returnToTaskDetailAction()
                }
            } else {
                null
            },
            linkedTasks = tasksState.tasks,
            onOpenTask = openLinkedTaskDetail,
            onUpgradePlan = onOpenSubscription,
            scrollToTopSignal = rootTabReselectEvents[HavnDestination.Clients] ?: 0
        )
        HavnDestination.Leads -> LeadsScreen(
            viewModel = leadsViewModel,
            followUpsViewModel = followUpsViewModel,
            onSendFollowUp = { leadId ->
                followUpsViewModel.openSendFollowUpForLead(leadId)
                onDestinationSelected(HavnDestination.FollowUps)
            },
            onFollowUpCompleted = {
                leadsViewModel.refresh()
            },
            onCreateTask = { lead ->
                if (agencyState.entitlement.isProAgent) {
                    tasksViewModel.startAddTask(
                        title = "Follow up with ${lead.fullName}",
                        description = lead.sourceLine,
                        propertyId = lead.propertyId,
                        contactId = lead.contactId,
                        openHouseId = lead.openHouseId,
                        leadId = lead.id
                    )
                    onDestinationSelected(HavnDestination.Tasks)
                } else {
                    onOpenSubscription()
                }
            },
            canUseAiFollowUps = canUseAiFollowUps,
            onAiUpgradeRequired = onOpenSubscription,
            detailBackLabel = when {
                returnToTaskDetail -> taskContextReturnLabel ?: LocalHavnStrings.current.taskDetail
                leadReturnOpeningId != null -> LocalHavnStrings.current.commonOpenHouse
                contactReturnClientId != null -> contactReturnLabel ?: LocalHavnStrings.current.clientsTitle
                else -> null
            },
            onBackFromDetail = when {
                returnToTaskDetail -> {
                    {
                        leadsViewModel.closeDetail()
                        onLeadReturnOpeningChanged(null)
                        returnToTaskDetailAction()
                    }
                }
                leadReturnOpeningId != null -> {
                    val openingId = leadReturnOpeningId
                    {
                        leadsViewModel.closeDetail()
                        openHousesViewModel.showExistingDetail(openingId)
                        onLeadReturnOpeningChanged(null)
                        onDestinationSelected(HavnDestination.OpenHouses)
                    }
                }
                contactReturnClientId != null -> {
                    val clientId = contactReturnClientId
                    {
                        leadsViewModel.closeDetail()
                        clientsViewModel.openClient(clientId)
                        onContactReturnChanged(null, null)
                        onDestinationSelected(HavnDestination.Clients)
                    }
                }
                else -> null
            },
            linkedTasks = tasksState.tasks,
            onOpenTask = openLinkedTaskDetail,
            scrollToTopSignal = rootTabReselectEvents[HavnDestination.Leads] ?: 0
        )
        HavnDestination.FollowUps -> FollowUpsScreen(
            viewModel = followUpsViewModel,
            onBackToLeadDetail = { onDestinationSelected(HavnDestination.Leads) },
            onFollowUpCompleted = {
                leadsViewModel.refresh()
            },
            canUseAiFollowUps = canUseAiFollowUps,
            onAiUpgradeRequired = onOpenSubscription
        )
        HavnDestination.Files -> if (canUseFiles) FilesScreen(
            state = attachmentsState,
            shareRecipients = shareRecipients,
            recentShareRecipients = attachmentsState.recentRecipients,
            isLoadingShareRecipients = clientsState.isLoadingShareRecipients,
            isLoadingMoreShareRecipients = clientsState.isLoadingMoreShareRecipients,
            hasMoreShareRecipients = clientsState.hasMoreShareRecipients,
            onBackToToday = phoneBackToToday ?: { onDestinationSelected(HavnDestination.Dashboard) },
            onLoadFiles = attachmentsViewModel::loadAllFiles,
            onOpenFile = attachmentsViewModel::openAttachment,
            onOpenShareRecipients = clientsViewModel::openShareRecipientPicker,
            onShareRecipientQueryChange = clientsViewModel::updateShareRecipientQuery,
            onLoadMoreShareRecipients = clientsViewModel::loadMoreShareRecipients,
            onSendEmail = { recipients, files -> attachmentsViewModel.sendSelectedEmail(recipients, files) },
            onSendSms = { recipients, files -> attachmentsViewModel.sendSelectedSms(recipients, files) },
            onDeleteFile = attachmentsViewModel::deleteAttachment
        ) else {
            LaunchedEffect(canUseFiles) { onOpenSubscription() }
        }
        HavnDestination.Reports -> if (canUseReports) {
            SellerReportsScreen(
                viewModel = sellerReportsViewModel,
                onBackToToday = phoneBackToToday,
                agencyId = selectedAgency?.id,
                agentName = kioskBranding.agentName,
                agencyName = kioskBranding.agencyName,
                shareRecipients = shareRecipients,
                linkedShareRecipients = agencyState.members.mapNotNull { it.toAttachmentRecipient() },
                recentShareRecipients = attachmentsState.recentRecipients,
                isLoadingShareRecipients = clientsState.isLoadingShareRecipients,
                isLoadingMoreShareRecipients = clientsState.isLoadingMoreShareRecipients,
                hasMoreShareRecipients = clientsState.hasMoreShareRecipients,
                isUploadingPdf = attachmentsState.isUploading,
                onUploadReportPdf = { propertyId, file, onUploaded, onFailed ->
                    attachmentsViewModel.uploadGeneratedForProperty(
                        propertyId = propertyId,
                        agencyId = selectedAgency?.id,
                        file = file,
                        onUploaded = onUploaded,
                        onFailed = onFailed
                    )
                },
                onOpenReportPdf = attachmentsViewModel::openAttachment,
                onSendReportEmail = { recipients, attachment ->
                    attachmentsViewModel.sendSelectedEmail(recipients, listOf(attachment))
                },
                onSendReportSms = { recipients, attachment ->
                    attachmentsViewModel.sendSelectedSms(recipients, listOf(attachment))
                },
                onOpenShareRecipients = clientsViewModel::openShareRecipientPicker,
                onShareRecipientQueryChange = clientsViewModel::updateShareRecipientQuery,
                onLoadMoreShareRecipients = clientsViewModel::loadMoreShareRecipients,
                onRecordShareRecipients = attachmentsViewModel::recordShareRecipients,
                onOpenProperty = { propertyId ->
                    openHousesViewModel.loadOpenHousesForProperty(propertyId)
                    propertiesViewModel.openProperty(propertyId)
                    onDestinationSelected(HavnDestination.Properties)
                    returnToTaskDetail = false
                    returnToSellerReport = true
                },
                scrollToTopSignal = rootTabReselectEvents[HavnDestination.Reports] ?: 0
            )
        } else {
            SettingsScreen(
                authRepository = authRepository,
                agencyViewModel = agencyViewModel,
                languageRepository = languageRepository,
                unitPreferencesRepository = unitPreferencesRepository,
                kioskSecurityRepository = kioskSecurityRepository,
                mcpApiKeyRepository = mcpApiKeyRepository,
                themeManager = themeManager,
                notificationRepository = notificationRepository,
                billingService = billingService,
                photoPicker = photoPicker,
                openPurchaseOnStart = true,
                onPurchaseStartConsumed = {},
                onLogout = onLogout,
                onAgentProfileChanged = onAgentProfileChanged,
                onDeleteAccount = { HavnExternalActions.openUrl(deleteAccountUrl) }
            )
        }
        HavnDestination.Tasks -> if (canUseTasks) {
            TasksScreen(
                viewModel = tasksViewModel,
                filePicker = filePicker,
                attachmentsState = attachmentsState,
                propertiesViewModel = propertiesViewModel,
                openHousesViewModel = openHousesViewModel,
                leadsViewModel = leadsViewModel,
                followUpsViewModel = followUpsViewModel,
                clientsViewModel = clientsViewModel,
                agencyViewModel = agencyViewModel,
                onOpenProperty = { propertyId ->
                    rememberTaskContextReturn()
                    onContactReturnChanged(null, null)
                    onOpeningReturnToTodayChanged(false)
                    onLeadReturnOpeningChanged(null)
                    openHousesViewModel.loadOpenHousesForProperty(propertyId)
                    propertiesViewModel.openProperty(propertyId)
                    onDestinationSelected(HavnDestination.Properties)
                },
                onOpenContact = { contactId ->
                    rememberTaskContextReturn()
                    onContactReturnChanged(null, null)
                    onOpeningReturnToTodayChanged(false)
                    onLeadReturnOpeningChanged(null)
                    clientsViewModel.openClient(contactId)
                    onDestinationSelected(HavnDestination.Clients)
                },
                onOpenOpening = { openingId ->
                    rememberTaskContextReturn()
                    onContactReturnChanged(null, null)
                    onOpeningReturnToTodayChanged(false)
                    onLeadReturnOpeningChanged(null)
                    openHousesViewModel.clearPropertyReturn()
                    openHousesViewModel.openDetail(openingId)
                    onDestinationSelected(HavnDestination.OpenHouses)
                },
                onOpenLead = { leadId ->
                    rememberTaskContextReturn()
                    onContactReturnChanged(null, null)
                    onOpeningReturnToTodayChanged(false)
                    onLeadReturnOpeningChanged(null)
                    leadsViewModel.openLead(leadId)
                    onDestinationSelected(HavnDestination.Leads)
                },
                onBackToToday = phoneBackToToday,
                taskDetailBackLabel = if (tasksState.detailBackTarget == TaskDetailBackTarget.Today) LocalHavnStrings.current.navToday else null,
                onTaskDetailBack = if (tasksState.detailBackTarget == TaskDetailBackTarget.Today) {
                    {
                        tasksViewModel.closeEditor()
                        onDestinationSelected(HavnDestination.Dashboard)
                    }
                } else {
                    null
                },
                onLoadAttachments = attachmentsViewModel::loadForTask,
                onUploadAttachment = { task, file ->
                    attachmentsViewModel.uploadForTask(task.id, task.propertyId, task.agencyId, file)
                },
                onOpenAttachment = attachmentsViewModel::openAttachment,
                onOpenPhotoAttachment = { photo -> HavnExternalActions.openUrl(photo.url) },
                onSendAttachmentEmail = attachmentsViewModel::sendSelectedEmail,
                onSendAttachmentSms = attachmentsViewModel::sendSelectedSms,
                onDeleteAttachment = attachmentsViewModel::deleteAttachment,
                onDismissAttachmentError = attachmentsViewModel::clearError,
                onUpgradePlan = onOpenSubscription,
                canUseFiles = canUseFiles,
                canUseAgencyTaskAgenda = canUseProModules,
                scrollToTopSignal = rootTabReselectEvents[HavnDestination.Tasks] ?: 0
            )
        } else {
            SettingsScreen(
                authRepository = authRepository,
                agencyViewModel = agencyViewModel,
                languageRepository = languageRepository,
                unitPreferencesRepository = unitPreferencesRepository,
                kioskSecurityRepository = kioskSecurityRepository,
                mcpApiKeyRepository = mcpApiKeyRepository,
                themeManager = themeManager,
                notificationRepository = notificationRepository,
                billingService = billingService,
                photoPicker = photoPicker,
                openPurchaseOnStart = true,
                onPurchaseStartConsumed = {},
                onLogout = onLogout,
                onAgentProfileChanged = onAgentProfileChanged,
                onDeleteAccount = { HavnExternalActions.openUrl(deleteAccountUrl) }
            )
        }
        HavnDestination.Analytics -> if (canUseAnalytics) {
            AnalyticsScreen(
                propertiesViewModel = propertiesViewModel,
                openHousesViewModel = openHousesViewModel,
                leadsViewModel = leadsViewModel,
                followUpsViewModel = followUpsViewModel,
                agencyViewModel = agencyViewModel,
                analyticsAiService = analyticsAiService,
                onBackToToday = phoneBackToToday,
                agentName = kioskBranding.agentName,
                agencyName = kioskBranding.agencyName ?: agencyState.workspaceName,
                shareRecipients = shareRecipients,
                linkedShareRecipients = agencyState.members.mapNotNull { it.toAttachmentRecipient() },
                recentShareRecipients = attachmentsState.recentRecipients,
                isLoadingShareRecipients = clientsState.isLoadingShareRecipients,
                isLoadingMoreShareRecipients = clientsState.isLoadingMoreShareRecipients,
                hasMoreShareRecipients = clientsState.hasMoreShareRecipients,
                isUploadingPdf = attachmentsState.isUploading,
                onUploadAnalyticsPdf = { file, onUploaded, onFailed ->
                    attachmentsViewModel.uploadGeneratedGlobal(
                        agencyId = selectedAgency?.id,
                        file = file,
                        onUploaded = onUploaded,
                        onFailed = onFailed
                    )
                },
                onOpenAnalyticsPdf = attachmentsViewModel::openAttachment,
                onSendAnalyticsEmail = { recipients, attachment ->
                    attachmentsViewModel.sendSelectedEmail(recipients, listOf(attachment))
                },
                onSendAnalyticsSms = { recipients, attachment ->
                    attachmentsViewModel.sendSelectedSms(recipients, listOf(attachment))
                },
                onOpenShareRecipients = clientsViewModel::openShareRecipientPicker,
                onShareRecipientQueryChange = clientsViewModel::updateShareRecipientQuery,
                onLoadMoreShareRecipients = clientsViewModel::loadMoreShareRecipients,
                onRecordShareRecipients = attachmentsViewModel::recordShareRecipients,
                scrollToTopSignal = rootTabReselectEvents[HavnDestination.Analytics] ?: 0
            )
        } else {
            SettingsScreen(
                authRepository = authRepository,
                agencyViewModel = agencyViewModel,
                languageRepository = languageRepository,
                unitPreferencesRepository = unitPreferencesRepository,
                kioskSecurityRepository = kioskSecurityRepository,
                mcpApiKeyRepository = mcpApiKeyRepository,
                themeManager = themeManager,
                notificationRepository = notificationRepository,
                billingService = billingService,
                photoPicker = photoPicker,
                openPurchaseOnStart = true,
                onPurchaseStartConsumed = {},
                onLogout = onLogout,
                onAgentProfileChanged = onAgentProfileChanged,
                onDeleteAccount = { HavnExternalActions.openUrl(deleteAccountUrl) }
            )
        }
        HavnDestination.Agency -> {
            val propertiesState by propertiesViewModel.uiState.collectAsState()
            val leadsState by leadsViewModel.uiState.collectAsState()
            AgencyScreen(
                viewModel = agencyViewModel,
                photoPicker = photoPicker,
                propertyCount = propertiesState.totalPropertyCount,
                leadCount = leadsState.leads.size,
                recentLeadTitle = leadsState.leads.firstOrNull()?.sourceLine,
                recentPropertyTitle = propertiesState.properties.firstOrNull()?.title,
                onBack = { onDestinationSelected(HavnDestination.Dashboard) },
                onManageAgency = { onDestinationSelected(HavnDestination.Settings) }
            )
        }
        HavnDestination.Settings -> SettingsScreen(
            authRepository = authRepository,
            agencyViewModel = agencyViewModel,
            languageRepository = languageRepository,
            unitPreferencesRepository = unitPreferencesRepository,
            kioskSecurityRepository = kioskSecurityRepository,
            mcpApiKeyRepository = mcpApiKeyRepository,
            themeManager = themeManager,
            notificationRepository = notificationRepository,
            billingService = billingService,
            photoPicker = photoPicker,
            openPurchaseOnStart = openSettingsPurchase,
            purchaseBackToToday = openSettingsPurchaseBackToToday,
            onPurchaseStartConsumed = onSettingsPurchaseConsumed,
            onAgentProfileChanged = onAgentProfileChanged,
            onBack = { onDestinationSelected(HavnDestination.Dashboard) },
            onLogout = onLogout,
            onDeleteAccount = { HavnExternalActions.openUrl(deleteAccountUrl) }
        )
    }
}

private fun resetDestinationToRoot(
    destination: HavnDestination,
    propertiesViewModel: PropertiesViewModel,
    openHousesViewModel: OpenHousesViewModel,
    leadsViewModel: LeadsViewModel,
    clientsViewModel: ClientsViewModel,
    followUpsViewModel: FollowUpsViewModel,
    sellerReportsViewModel: SellerReportsViewModel,
    attachmentsViewModel: AttachmentsViewModel
) {
    when (destination) {
        HavnDestination.Properties -> propertiesViewModel.closeDetail()
        HavnDestination.OpenHouses -> openHousesViewModel.showList()
        HavnDestination.Clients -> clientsViewModel.openList()
        HavnDestination.Leads -> leadsViewModel.closeDetail()
        HavnDestination.FollowUps -> followUpsViewModel.openQueue()
        HavnDestination.Files -> attachmentsViewModel.loadAllFiles()
        HavnDestination.Reports -> sellerReportsViewModel.openList()
        HavnDestination.Tasks -> Unit
        HavnDestination.Analytics -> Unit
        HavnDestination.Auth,
        HavnDestination.Dashboard,
        HavnDestination.Agency,
        HavnDestination.Settings -> Unit
    }
}

private fun routeHavnDeepLink(
    link: String,
    propertiesViewModel: PropertiesViewModel,
    openHousesViewModel: OpenHousesViewModel,
    leadsViewModel: LeadsViewModel,
    sellerReportsViewModel: SellerReportsViewModel,
    onDestinationSelected: (HavnDestination) -> Unit,
    onOpenSubscription: () -> Unit
) {
    val normalized = link.removePrefix("havn://").trim('/')
    val parts = normalized.split('/').filter { it.isNotBlank() }
    val id = parts.getOrNull(1) ?: return
    when (parts.firstOrNull()) {
        "lead" -> {
            leadsViewModel.openLead(id)
            onDestinationSelected(HavnDestination.Leads)
        }
        "property" -> {
            propertiesViewModel.openProperty(id)
            onDestinationSelected(HavnDestination.Properties)
        }
        "open-house" -> {
            openHousesViewModel.openDetail(id)
            onDestinationSelected(HavnDestination.OpenHouses)
        }
        "report" -> {
            sellerReportsViewModel.openList()
            onDestinationSelected(HavnDestination.Reports)
        }
        "agency" -> onDestinationSelected(HavnDestination.Agency)
        "settings" -> onOpenSubscription()
    }
}

private fun HavnDestination.navigationDepth(): Int = when (this) {
    HavnDestination.Auth -> 0
    HavnDestination.Dashboard -> 0
    HavnDestination.Properties -> 1
    HavnDestination.OpenHouses -> 2
    HavnDestination.Clients -> 3
    HavnDestination.Leads -> 4
    HavnDestination.FollowUps -> 5
    HavnDestination.Files -> 5
    HavnDestination.Reports -> 5
    HavnDestination.Tasks -> 5
    HavnDestination.Analytics -> 5
    HavnDestination.Agency -> 5
    HavnDestination.Settings -> 5
}

private val HavnDestination.isProModule: Boolean
    get() = this == HavnDestination.Tasks ||
        this == HavnDestination.Reports ||
        this == HavnDestination.Analytics

private fun OpenHousesMode.usesKioskImmersiveChrome(): Boolean =
    this == OpenHousesMode.LiveDashboard || this == OpenHousesMode.VisitorKiosk

private fun Client.toAttachmentRecipient(): HavnAttachmentRecipient = HavnAttachmentRecipient(
    id = "contact:$id",
    displayName = fullName,
    email = email,
    phone = phone,
    source = HavnAttachmentRecipientSource.Contact
)

private fun AgencyMember.toAttachmentRecipient(): HavnAttachmentRecipient? {
    val memberId = agentId ?: invitationId ?: email.takeIf { it.isNotBlank() } ?: return null
    return HavnAttachmentRecipient(
        id = "agent:$memberId",
        displayName = fullName,
        email = email.takeIf { it.isNotBlank() },
        phone = null,
        source = HavnAttachmentRecipientSource.Agent
    )
}

private fun List<HavnAttachmentRecipient>.dedupeAttachmentRecipients(): List<HavnAttachmentRecipient> =
    distinctBy { it.id }

private val HavnSubscriptionTier.displayLabel: String
    get() = when (this) {
        HavnSubscriptionTier.Free -> "Free"
        HavnSubscriptionTier.SoloAgent -> "Solo Agent"
        HavnSubscriptionTier.ProAgent -> "Pro Agent"
        HavnSubscriptionTier.TeamAgent -> "Team"
    }

private fun deleteAccountUrl(language: HavnLanguage): String =
    if (language == HavnLanguage.English) {
        "https://havnre.app/deleteaccount/"
    } else {
        "https://havnre.app/${language.code}/deleteaccount/?locale=${language.code}"
    }
